import React, { Component } from 'react'
import '../styles/Cart.css'
import '../styles/CartItem.css'
import { withRouter, Link } from 'react-router-dom'
import Field from './Field'
import CartItem from './CartItem'
import CartItemVoucher from './CartItemVoucher'
import MailIcon from '../images/Cart/mail.png'
import CouponIcon from '../images/Cart/coupon.png'
import CreditCardIcon from '../images/Cart/credit-card.png'
import AncvIcon from '../images/Cart/ancv.png'
import PassCultureIcon from '../images/Cart/passculture.png'
import smoothscroll from 'smoothscroll'
import { Cookies } from 'react-cookie-banner'
import { API_ROOT } from '../api-config'
import axios from 'axios'
import validator from 'email-validator'
import { injectIntl, defineMessages } from 'react-intl'
import qs from 'qs'
import { domain, prodTag } from '../webURL'

const status = { step1: 0, step2: 1, step3: 2};
const voucherTypes = { reduc: "reduc", ancv: "ancv", passculture: "pass_culture" };
const ancvCheckValueS = 5;
const passCultureCheckValueS = 5;
const themeCodeConverter = (code) => {
  switch (code) {
    case '27':
      return "Lost Asylum"
    case '28':
      return "Very Bad Night"
    case '29':
      return "L'Abattoir"
    case '31':
      return "Yakuza"
    case '31':
      return "L'expédition maudite"
    default:
      break
  }
}

const buildFormBody = (body) => {
  let formBody = []

  for (let property in body) {
    const encodedKey = encodeURIComponent(property);
    const encodedValue = encodeURIComponent(body[property]);
    formBody.push(encodedKey + "=" + encodedValue);
  }

  formBody = formBody.join("&")

  return formBody
}

const stripTimeBegin = (time) => {
  return `${time.split(":")[0]}h00`
}

const formatDateWithZero = (date) => {
  const formattedDate = date.split("-")
  let y, M, d

  y = formattedDate[0]
  M = formattedDate[1].length < 2 ? `0${formattedDate[1]}` : formattedDate[1]
  d = formattedDate[2].length < 2 ? `0${formattedDate[2]}` : formattedDate[2]

  return `${d}/${M}/${y}`
}

const createDate = (booking) => {
  return `${formatDateWithZero(booking.reservation_date)} à ${stripTimeBegin(booking.time_begin)}`
}

const buildAPI_URL = (idOrder, tokenOrder) => {
  return `${API_ROOT}FrontGetOrderDetails.php?id_order=${idOrder}&token_order=${tokenOrder}`
}

const buildAPI_URL_Booking = (idReservation, tokenReservation) => {
  return `${API_ROOT}FrontGetReservationDetails.php?id_reservation=${idReservation}&token_reservation=${tokenReservation}`
}

const buildAPI_URL_Cart = (idOrder, tokenOrder) => {
  return `${API_ROOT}FrontGetOrderCart.php?id_order=${idOrder}&token_order=${tokenOrder}`
}

var hasPaperCard = function(voucher) {
  return voucher.paper_card === true
}

class Cart extends Component {
  constructor(props) {
    super(props)
    const cookies = new Cookies();
    this.state = {
      firstName: null,
      lastName: null,
      telephone: null,
      email: null,
      emailIsValid: false,
      formIsValid: true,
      formIsValidRecipient: true,
      comment: null,
      player1: null,
      player2: null,
      player3: null,
      player4: null,
      playersEmail: {},
      playersFormOpacity: "0",
      userIsPlaying: null,
      sendToPlayers: false,
      userIsCorporate: false,
      companyName: "",
      companyAddress: "",
      companyPostalCode: "",
      companyCity: "",
      userIsPlaying: true,
      userAcceptsTerms: false,
      userAcceptsTermsError: false,
      couponCode: "",
      hasCouponCode: false,
      hasValidCouponCode: false,
      couponCodeDiscount: 0,
      couponCodePercent: false,
      couponsList: [],
      numberOfPlayers: "",
      numberOfGames: "",
      paperCard: false,
      paperCardNote: "",
      recipientFirstName: null,
      recipientLastName: null,
      recipientStreetAddress: null,
      recipientPostalCode: null,
      recipientCity: null,
      recipientCountry: null,
      bookings: [],
      vouchers: [],
      vouchersByPostCard: [],
      displayOrderDetails: true,
      onlyPayment: false,
      status: status.step1,
      voucherPromo: false,
      voucherAncv: false,
      voucherPassCulture: false,
      voucherMessage: "",
      cartTotalOpened: false,
      totalPrice: null,
      totalPriceDiscount: 0,
      totalOptions: 0,
      totalPriceWithOptions: 0,
      ancvIdentifier: null,
      passCultureReservation: null,
      ancvError: null,
      passCultureError: null,
      showVoucherPaymentOverlay: false,
      showAddPassCulture: true,
      showSuccessPassCulture: false,
      isInPayment: false,
      genericError: false,
      multiPayment: false,
      multiPaymentFee: (cookies.get("orderDetails") && cookies.get("orderDetails").multipayment_fee) ? cookies.get("orderDetails").multipayment_fee : -1,
      multiPaymentLimit: (cookies.get("orderDetails") && cookies.get("orderDetails").multipayment_limit_h) ? cookies.get("orderDetails").multipayment_limit_h : 0,
      multiPaymentEmails: ["", ""],
      maxMultiPaymentEmails: 2,
      multiPaymentAcceptsTerms: false,
      multiPaymentFormIsValid: true,
      multiPaymentLoader: false,
      order_status: null
    }
    this.ancvInterval = null;
  }

  toggleSendToPlayers = () => {
    if (this.state.sendToPlayers) {
      this.setState({
        sendToPlayers: false,
      })
      window.setTimeout(() => {
        this.setState({ playersFormOpacity: "0"})
      }, 100)
    } else {
      this.setState({
        sendToPlayers: true,
      })
      window.setTimeout(() => {
        this.setState({ playersFormOpacity: "1"})
      }, 100)
    }

  }

  getCouponsList = (type) => {
    return this.state.couponsList.filter((coupon) => {
      return coupon.voucherType === type;
    });
  };

  toggleCartTotalOpened = () => {
     this.setState({
        cartTotalOpened: !this.state.cartTotalOpened,
      });
  };

  scrollToSendToPlayers = () => {
    if (!this.state.sendToPlayers) {
      smoothscroll(document.getElementById("send-to-players-button"), 1000)
    }
  }

  handleCTA = () => {
    if (!this.state.isInPayment) {
      if (this.state.onlyPayment) {
        //this.handleCTAOnlyPayment()
      }
      const isVoucherOrder = this.state.vouchers.length > 0
      if (!this.state.userAcceptsTerms || (this.state.multiPayment && !this.state.multiPaymentAcceptsTerms)) {
        this.setState({ userAcceptsTermsError: true })
      } else if (!this.validateForm()) {
        this.setState({ formIsValid: false }, smoothscroll(document.getElementById("cart-summary-error-anchor")))
      } else if (!this.validateFormMultiPayment()) {
        this.setState({ multiPaymentFormIsValid: false }, smoothscroll(document.getElementById("cart-multi-payment-email-error-anchor")))
      } else if (!this.validateFormRecipient() && isVoucherOrder) {
        this.setState({ formIsValid: true, multiPaymentFormIsValid: true })
        this.setState({ formIsValidRecipient: false })
      } else if (isVoucherOrder) {
        this.setState({ isInPayment: true });
        this.confirmOrderVoucher()
      } else if (this.state.bookings && this.state.bookings.length > 0) {
        this.setState({ isInPayment: true });
        this.getOrderInfoBeforePayment()
      } else {
        this.setState({ genericError: true });
      }
    }
  }

  handleCTAOnlyPayment = () => {
    if (!this.state.userAcceptsTerms) {
      this.setState({ userAcceptsTermsError: true })
    } else {
      this.confirmOnlyPayOrder()
    }
  }

  validateFormMultiPayment = () => {
    if (!this.state.multiPayment) {
      return true;
    }

    const emails = this.state.multiPaymentEmails;
    const uniqueEmails = new Set(emails);

    return emails.every(email => validator.validate(email)) && uniqueEmails.size === emails.length;
  }

  validateForm = () => {
    // For autofill
    
    this.setState({ firstName: document.querySelector(`input[name="fname"]`).value });
    this.setState({ lastName: document.querySelector(`input[name="lname"]`).value });
    this.setState({ telephone: document.querySelector(`input[name="phone"]`).value });
    this.setState({ email: document.querySelector(`input[name="email"]`).value });

    if (this.state.multiPaymentEmails == null || this.state.multiPaymentEmails.length == 0)
      this.setState({multiPaymentEmails: [this.state.email]});

    return this.state.firstName !== null && this.state.lastName !== null && this.state.telephone !== null && validator.validate(this.state.email);
  }

  validateFormRecipient = () => {
    if (this.state.vouchers && this.state.paperCard) {
      return this.state.recipientFirstName && this.state.recipientLastName && this.state.recipientStreetAddress && this.state.recipientPostalCode && this.state.recipientCity && this.state.recipientCountry
    } else if (this.state.vouchers) {
      return true
    } else {
      return false
    }
  }

  getCardInfo = () => {
    if (this.props.location.params.card) {
      const card = this.props.location.params.card
      this.setState({
        totalPrice: card.price,
        numberOfPlayers: card.numberOfPlayers,
        numberOfGames: card.numberOfGames,
        paperCard: card.paperCard
      })
    }
  }

  updateBookings = async () => {
    const cookies = new Cookies()
    const bookings = []
    if (Array.isArray(cookies.get('bookings')) && cookies.get('bookings').length > 0) {
      await cookies.get('bookings').forEach(reservation => {
        bookings.push(reservation)
      })
      await this.setState({ bookings: bookings})
      this.setTotalPrice()
    }
    if (this.state.bookings.length < 1 && !this.props.location.params) {
      this.props.history.push({
        pathname: "/reserver/"
      })
    } else if (this.state.vouchers < 1 && this.props.location.params) {
      this.props.history.push({
        pathname: "/carte-cadeaux/"
      })
    }
  }

  setTotalPrice = () => {
    let totalPrice = 0
    let totalPriceWithOptions = 0;
    this.state.bookings.forEach(x => {
      totalPrice = totalPrice + x.price_reservation_total_without_promo
      totalPriceWithOptions = totalPriceWithOptions + x.price_reservation_total_without_promo;
    })
    this.setState({ totalPrice: totalPrice, totalPriceWithOptions: totalPriceWithOptions })
    let totalPriceDiscount = this.computePriceWithDiscount(totalPrice, this.state.couponCodeDiscount)
    this.setState({ totalPriceDiscount: totalPriceDiscount })
  }

  computePriceWithDiscount = (price, discount) => {
    const multipaymentFee = this.state.multiPayment ? this.state.multiPaymentFee : 0;
    if (this.state.couponCodePercent && discount > 0) {
      return price - (price * discount * 0.01) + multipaymentFee
    } else {
      return price - discount + multipaymentFee
    }
  }


  handleCouponCode = async (code, type) => {

    if (voucherTypes.reduc === type && this.getCouponReduc()) {
      // Do not allow another coupon code
      return null;
    }
    const url = `${API_ROOT}FrontAddVoucherToOrder.php`
    const {intl:{formatMessage}} = this.props
    const cookies = new Cookies()
    let orderDetails
    if (cookies.get("vouchers") && cookies.get("vouchers") != 'null') {
      orderDetails = cookies.get("orderDetailsVouchers")
    } else {
      orderDetails = cookies.get("orderDetails")
    }
    const idOrder = orderDetails.id_order_escape
    const tokenOrder = orderDetails.id_order_escape_token

    const body = {
      id_order: idOrder,
      token_order: tokenOrder,
      code_voucher: code
    }

    return await fetch(url, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
          },
      method: 'post',
      body: buildFormBody(body)
    })
    .then(response => response.json())
    .then(data => {
      if (data.result) {
        let value = data.voucher_value
        let voucherType = data.voucher_type === "pourcent"

        const newCoupon = {
          voucherCode: code,
          voucherValue: parseFloat(value, 10).toFixed(2),
          voucherPercent: voucherType,
          voucherType: voucherTypes.reduc,
          voucherTitle: formatMessage(messages.voucher),
          voucherData: data
        }
        this.setState({
            hasCouponCode: true,
            hasValidCouponCode: true,
            couponCodeDiscount: parseFloat(value, 10).toFixed(2),
            couponCodePercent: voucherType,
            totalPriceDiscount: data.price
        })
        this.setState({couponsList: []});
        if (voucherTypes.reduc === newCoupon.voucherType) {
          // Clear voucher reduc if existing in array
          let pos = -1;
          this.state.couponsList.forEach((voucher, i) => {
            if (voucherTypes.reduc === voucher.voucherType) {
              pos = i;
            }
          });
          
          if (pos > -1) {
            // Clean and add voucher to array
            const lCouponsList = [...this.state.couponsList];
            lCouponsList.splice(pos, 1);
            this.setState({
                voucherPromo: true,
                couponsList: [...lCouponsList, newCoupon]
            });
          } else {
            // Add voucher to array 
            this.setState({
                voucherPromo: true,
                couponsList: [...this.state.couponsList, newCoupon]
            });
          }
        }

        // Add other coupons
        if (data.coupons && data.coupons.length > 0) {
          data.coupons.forEach((coupon) => {
            const newCoupon = {
              voucherCode: coupon.voucher_used,
              voucherValue: parseFloat(coupon.voucher_value, 10).toFixed(2),
              voucherPercent: false,
              voucherType: coupon.voucher_vtype,
              voucherTitle: coupon.voucher_vtype === voucherTypes.ancv ? formatMessage(messages.voucherAncv) : formatMessage(messages.voucherPasseCulture),
              voucherData: data,
              voucherName: coupon.voucher_name
            }
            if (coupon.voucher_vtype === voucherTypes.passculture) {
              this.setState({
                  showAddPassCulture: false
              });
            }


            if (voucherTypes.reduc != coupon.voucher_vtype) {
              this.setState({
                  couponsList: [...this.state.couponsList, newCoupon]
              });
            }

            if (voucherTypes.ancv === coupon.voucher_vtype) {
              this.setState({voucherAncv: true});
            }

            if (voucherTypes.passculture === coupon.voucher_vtype) {
              this.setState({voucherPassCulture: true});
            }
          });
        }
      } else {
        this.setState({ hasCouponCode: true, hasValidCouponCode: false, voucherMessage: data.message })
      }
    })
    .catch(error => console.log(error))
  }


  handleAncvCancel  = () => {
    // Cancel ancv payment
    const {intl:{formatMessage}} = this.props
    const cookies = new Cookies()

    let orderDetails;
    if (cookies.get("vouchers") && cookies.get("vouchers") != 'null') {
      orderDetails = cookies.get("orderDetailsVouchers")
    } else {
      orderDetails = cookies.get("orderDetails")
    }
    const idOrder = orderDetails.id_order_escape
    const tokenOrder = orderDetails.id_order_escape_token

    const body = {
      id_order: idOrder,
      token_order: tokenOrder
    }

    this.setState({ancvError: null, showVoucherPaymentOverlay: false, voucherAncv: false});

    fetch(`${API_ROOT}Ancv.php?ancv=cancel`, {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
            method: 'post',
            body: buildFormBody(body)
          })
          .then(response => response.json())
          .then(data => {
            // All is ok
            if (this.ancvInterval) {
              clearInterval(this.ancvInterval);
              this.ancvInterval = null;
            }
            if (data && data.success) {
              // Do nothing 
            } else {
              this.setState({ancvError: data.message, showVoucherPaymentOverlay: false, voucherAncv: true});
            }
          })
          .catch(error => console.log(error))
  }

  handleAncvResponse = () => {
    // Wait for ancv payment
    const {intl:{formatMessage}} = this.props
    const cookies = new Cookies()

    let orderDetails;
    if (cookies.get("vouchers") && cookies.get("vouchers") != 'null') {
      orderDetails = cookies.get("orderDetailsVouchers")
    } else {
      orderDetails = cookies.get("orderDetails")
    }
    const idOrder = orderDetails.id_order_escape
    const tokenOrder = orderDetails.id_order_escape_token

    const body = {
      id_order: idOrder,
      token_order: tokenOrder
    }

    this.setState({ancvError: null, showVoucherPaymentOverlay: true, voucherAncv: true});

    this.ancvInterval = null;
    this.ancvInterval = setInterval((self) => {
      fetch(`${API_ROOT}Ancv.php?ancv=check`, {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                  },
              method: 'post',
              body: buildFormBody(body)
            })
            .then(response => response.json())
            .then(data => {
              if (data && data.success) {
                clearInterval(this.ancvInterval);
                self.setState({ancvError: null, showVoucherPaymentOverlay: false });
                this.ancvInterval = null;
                self.getOrderInfo();
              } else {
                if ("NO_CALLBACK" != data.message) {
                  clearInterval(this.ancvInterval);
                  self.setState({ancvError: data.message, showVoucherPaymentOverlay: false});
                  this.ancvInterval = null;
                  self.getOrderInfo(); 
                }
              }
            })
            .catch(error => console.log(error))
    }, ancvCheckValueS * 1000, this);
  };

  handleAncv = async (identifier) => {

    if (this.getCouponAncv().value > 0) {
      // Do not allow another coupon code
      return null;
    }
    const url = `${API_ROOT}Ancv.php`
    const {intl:{formatMessage}} = this.props
    const cookies = new Cookies()
    let orderDetails;
    if (cookies.get("vouchers") && cookies.get("vouchers") != 'null') {
      orderDetails = cookies.get("orderDetailsVouchers")
    } else {
      orderDetails = cookies.get("orderDetails")
    }
    const idOrder = orderDetails.id_order_escape
    const tokenOrder = orderDetails.id_order_escape_token

    const body = {
      id_order: idOrder,
      token_order: tokenOrder,
      ancv_identifier: identifier
    }

    return await fetch(url, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
          },
      method: 'post',
      body: buildFormBody(body)
    })
    .then(response => response.json())
    .then(data => {
      if (data && data.success) {
        this.handleAncvResponse();
      } else {
        this.setState({ancvError: data.message});
      }
      
    })
    .catch(error => console.log(error))
  }

  handlePassCulture = async (identifier) => {

    if (this.getCouponPassCulture().value > 0) {
      // Do not allow another coupon code
      return null;
    }
    const url = `${API_ROOT}PassCulture.php`
    const {intl:{formatMessage}} = this.props
    const cookies = new Cookies()
    let orderDetails;
    if (cookies.get("vouchers") && cookies.get("vouchers") != 'null') {
      orderDetails = cookies.get("orderDetailsVouchers")
    } else {
      orderDetails = cookies.get("orderDetails")
    }
    const idOrder = orderDetails.id_order_escape
    const tokenOrder = orderDetails.id_order_escape_token

    const body = {
      id_order: idOrder,
      token_order: tokenOrder,
      passculture_code: identifier
    }

    return await fetch(url, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
          },
      method: 'post',
      body: buildFormBody(body)
    })
    .then(response => response.json())
    .then(data => {
      if (data && data.success) {
        this.getOrderInfo();
        this.setState({passCultureError: null, showSuccessPassCulture: true});
      } else {
        this.setState({passCultureError: data.message, showSuccessPassCulture: false});
      }
      
    })
    .catch(error => console.log(error))
  }

  updateNewBookings = (booking) => {
    const cookies = new Cookies()
    const bookings = booking.rooms
    cookies.set('bookings', bookings, { path: '/', expires: new Date('2040-12-17T03:24:00') })
    this.setState({ bookings: bookings })
    this.getOrderInfo()
  }

  showOrderDetails = () => {
    const orderDetails = document.getElementById("order-details")
    if (orderDetails) {
      this.setState({ displayOrderDetails: true })
      orderDetails.style.display = "inline-block"
      orderDetails.style.maxHeight = orderDetails.scrollHeight + "px"
    }
  }  

  toggleOrderDetails = () => {
    const orderDetails = document.getElementById("order-details")

    if (!this.state.displayOrderDetails) {
      this.showOrderDetails();
    } else {
      orderDetails.style.maxHeight = "0"
      window.setTimeout(x => {
        orderDetails.style.display = "none"
      }, 200)
      this.setState({ displayOrderDetails: false })
    }
  }

  getOrderInfo = async (cb = null) => {
    const {intl:{formatMessage}} = this.props
    const bookingCheckout = this.state.bookings.length > 0;
    const cookies = new Cookies()
    let orderDetails
    if (cookies.get("vouchers") && cookies.get("vouchers") != 'null') {
      orderDetails = cookies.get("orderDetailsVouchers")
    } else {
      orderDetails = cookies.get("orderDetails")
    }
    const idOrder = orderDetails.id_order_escape
    const tokenOrder = orderDetails.id_order_escape_token

    const self = this;
    axios.get(buildAPI_URL(idOrder, tokenOrder))
      .then(async (response) => {
        let value = response.data.voucher_value

        let totalOptions = 0;
        let totalPriceWithOptions = 0;
        let totalPrice = 0;
        let order_status = response.data.status ? response.data.status : null;
        if (response && response.data && response.data.multipayment_fee) this.setState({ multiPaymentFee: response.data.multipayment_fee});
        if (response.data.multipayment && response.data.multipayment.length > 0) { 
          this.setState({ multiPayment: response.data.multipayment, multiPaymentEmails: response.data.multipayment_emails });
        }
        if (response.data && response.data.rooms && response.data.rooms.length > 0) {
          response.data.rooms.forEach((room) => {
            if (room.room_option_price && room.room_option_price > 0) {
              totalOptions += room.room_option_price;
            }
            totalPriceWithOptions += room.price_reservation_total_without_promo;
            totalPrice += parseFloat(room.reservation_price_without_promo);
          });

          this.setState({totalOptions: totalOptions, totalPriceWithOptions: totalPriceWithOptions, totalPrice: totalPrice});
        }

        let voucherType = response.data.voucher_type === "pourcent"
        this.setState({ couponsList: [], order_status: order_status });
        if (response.data.voucher_value !== null && bookingCheckout) {
          const newCoupon = {
            voucherCode: response.data.voucher_used,
            voucherValue: parseFloat(value, 10).toFixed(2),
            voucherPercent: voucherType,
            voucherType: voucherTypes.reduc,
            voucherTitle: formatMessage(messages.voucher),
            voucherData: response.data
          }
          this.setState({
            hasValidCouponCode: true,
            hasCouponCode: true,
            couponCode: response.data.voucher_used,
            couponCodeDiscount: parseFloat(value, 10).toFixed(2),
            couponCodePercent: voucherType,
            totalPriceDiscount: response.data.price,
            voucherPromo: true            
          })
          
          if (voucherTypes.reduc === newCoupon.voucherType) {
            // Clear voucher reduc if existing in array
            let pos = -1;
            this.state.couponsList.forEach((voucher, i) => {
              if (voucherTypes.reduc === voucher.voucherType) {
                pos = i;
              }
            });
            
            if (pos > -1) {
              // Clean and add voucher to array
              const lCouponsList = [...this.state.couponsList];
              lCouponsList.splice(pos, 1);
              this.setState({
                  voucherPromo: true,
                  couponsList: [...lCouponsList, newCoupon]
              });
            } else {
              // Add voucher to array
              this.setState({
                  voucherPromo: true,
                  couponsList: [...this.state.couponsList, newCoupon]
              });
            }
          }

        } else {
          this.setState({
            totalPriceDiscount: response.data.price
          })
        }

        // Add other coupons
        if (response.data.coupons && response.data.coupons.length > 0) {
          response.data.coupons.forEach((coupon) => {
            const newCoupon = {
              voucherCode: coupon.voucher_used,
              voucherValue: parseFloat(coupon.voucher_value, 10).toFixed(2),
              voucherPercent: false,
              voucherType: coupon.voucher_vtype,
              voucherTitle: coupon.voucher_vtype === voucherTypes.ancv ? formatMessage(messages.voucherAncv) : formatMessage(messages.voucherPasseCulture),
              voucherData: response.data,
              voucherName: coupon.voucher_name
            }
            if (coupon.voucher_vtype === voucherTypes.passculture) {
              this.setState({
                  showAddPassCulture: false
              });
            }

            if (voucherTypes.reduc != coupon.voucher_vtype) {
              this.setState({
                  couponsList: [...this.state.couponsList, newCoupon]
              });
            }

            if (voucherTypes.ancv === coupon.voucher_vtype) {
              this.setState({voucherAncv: true});
            }

            if (voucherTypes.passculture === coupon.voucher_vtype) {
              this.setState({voucherPassCulture: true});
            }
          });
        }

        if (response.data && response.data.isWaitingAncvPayment && this.getCouponsList(voucherTypes.ancv).length == 0) {
          this.handleAncvResponse();
        }
        
        self.showOrderDetails();
        if (cb) cb();
      })
      .catch(error => console.log(error))
  }

  getOrderInfoBeforePayment = () => {
    const cookies = new Cookies()
    const idOrder = cookies.get('orderDetails').id_order_escape
    const tokenOrder = cookies.get('orderDetails').id_order_escape_token
    axios.get(buildAPI_URL(idOrder, tokenOrder))
      .then(async (response) => {
        if (!response.data.result) {
          this.props.history.push({
            pathname: "/reserver/",
          })
        } else {
          this.confirmOrder()
        }
      })
      .catch(error => {
        window.location.reload()
        console.log(error)
      })
  }

  getOrderInfoFromURLQuery = async (id, token) => {
    const idOrder = id;
    const tokenOrder = token;
    const self = this;
    axios.get(buildAPI_URL_Cart(idOrder, tokenOrder))
      .then(async response => {
        let bookings = []
        await response.data.rooms.forEach(reservation => {
          bookings.push(reservation)
        })

        response.data.id_order_escape = id;
        response.data.id_order_escape_token = token;
        let order_status = response.data.status ? response.data.status : null;
        if (response && response.data && response.data.multipayment_fee) this.setState({ multiPaymentFee: response.data.multipayment_fee });
        this.setState({ multiPayment: response.data.multipayment, multiPaymentEmails: response.data.multipayment_emails });

        this.setState({
          status: status.step2,
          firstName: response.data.firstname ? response.data.firstname : null,
          lastName: response.data.lastname ? response.data.lastname : null,
          telephone: response.data.phone ? response.data.phone : null,
          email: response.data.email ? response.data.email : null,
          comment: response.data.comment ? response.data.comment : null,
          userIsCorporate: (response.data && response.data.is_company == "1"),
          companyName: response.data.company_name ? response.data.company_name : null,
          companyAddress: response.data.address ? response.data.address : null,
          companyPostalCode: response.data.postal_code ? response.data.postal_code : null,
          companyCity: response.data.city ? response.data.city : null,
          order_status: order_status,
        });

        if (response.data.firstname
            || response.data.lastname
            || response.data.phone
            || response.data.email
            || response.data.comment
            || response.data.is_company == "1"
            || response.data.company_name
            || response.data.address
            || response.data.postal_code
            || response.data.city) {
          await this.setState({status: status.step3});
        }
        document.getElementsByClassName("cart-book-back")[0].style.display = 'none';
        

        const cookies = new Cookies()
        if (response.data.rooms && response.data.rooms.length > 0) {
          cookies.set("orderDetails", response.data, { path: '/', expires: new Date('2040-12-17T03:24:00') });
          cookies.set('bookings', response.data.rooms, { path: '/', expires: new Date('2040-12-17T03:24:00') })
        } else {
          cookies.set("orderDetailsVouchers", response.data, { path: '/', expires: new Date('2040-12-17T03:24:00') });
          cookies.set("vouchers", response.data.vouchers, { path: '/', expires: new Date('2040-12-17T03:24:00') });
        }
        
        await this.setState({ bookings: bookings, onlyPayment: true })
        this.setTotalPrice()
        this.setState({ totalPrice: response.data.price, vouchers: response.data.vouchers })

        const {intl:{formatMessage}} = this.props
        const bookingCheckout = this.state.bookings.length > 0;

        // if (response.data.voucher_value !== null) {
        //   let voucherTypePercent = response.data.voucher_type === "pourcent"
        //   this.setState({
        //     hasValidCouponCode: true,
        //     hasCouponCode: true,
        //     couponCode: response.data.voucher_used,
        //     couponCodeDiscount: response.data.voucher_value,
        //     couponCodePercent: voucherTypePercent
        //   })
        // }

        // this.getOrderInfo();

        let value = response.data.voucher_value

        let totalOptions = 0;
        let totalPriceWithOptions = 0;
        let totalPrice = 0;
        let playersEmail = [];
        let playersFormOpacity = "0";
        let sendToPlayers = false;
        
        if (response.data && response.data.rooms && response.data.rooms.length > 0) {
          response.data.rooms.forEach((room) => {
            if (room.email_players) {
              playersEmail[room.id] = room.email_players.split(";");
              if (playersEmail[room.id].length > 0) {playersFormOpacity = "1"; sendToPlayers = true; }
            }

            if (room.room_option_price && room.room_option_price > 0) {
              totalOptions += room.room_option_price;
            }
            totalPriceWithOptions += room.price_reservation_total_without_promo;
            totalPrice += parseFloat(room.reservation_price_without_promo);
          });

          this.setState({totalOptions: totalOptions, totalPriceWithOptions: totalPriceWithOptions, totalPrice: totalPrice});
        }
        this.setState({
          playersEmail: playersEmail,
          playersFormOpacity: playersFormOpacity,
          sendToPlayers: sendToPlayers
        });

        if (!bookingCheckout && response.data && response.data.vouchers && response.data.vouchers.length > 0) {
          response.data.vouchers.forEach((voucher) => {
            totalPrice += parseInt(voucher.price);
          });

          this.setState({totalOptions: totalOptions, totalPriceWithOptions: totalPriceWithOptions, totalPrice: totalPrice});
        }


 
        let voucherType = response.data.voucher_type === "pourcent"
        this.setState({couponsList: []});
        if (response.data.voucher_value !== null && bookingCheckout) {
          const newCoupon = {
            voucherCode: response.data.voucher_used,
            voucherValue: parseFloat(value, 10).toFixed(2),
            voucherPercent: voucherType,
            voucherType: voucherTypes.reduc,
            voucherTitle: formatMessage(messages.voucher),
            voucherData: response.data
          }
          this.setState({
            hasValidCouponCode: true,
            hasCouponCode: true,
            couponCode: response.data.voucher_used,
            couponCodeDiscount: parseFloat(value, 10).toFixed(2),
            couponCodePercent: voucherType,
            totalPriceDiscount: response.data.price,
            voucherPromo: true            
          })
          
          if (voucherTypes.reduc === newCoupon.voucherType) {
            // Clear voucher reduc if existing in array
            let pos = -1;
            this.state.couponsList.forEach((voucher, i) => {
              if (voucherTypes.reduc === voucher.voucherType) {
                pos = i;
              }
            });
            
            if (pos > -1) {
              // Clean and add voucher to array
              const lCouponsList = [...this.state.couponsList];
              lCouponsList.splice(pos, 1);
              this.setState({
                  voucherPromo: true,
                  couponsList: [...lCouponsList, newCoupon]
              });
            } else {
              // Add voucher to array
              this.setState({
                  voucherPromo: true,
                  couponsList: [...this.state.couponsList, newCoupon]
              });
            }
          }

        } else {
          this.setState({
            totalPriceDiscount: response.data.price
          })
        }

        // Add other coupons
        if (response.data.coupons && response.data.coupons.length > 0) {
          response.data.coupons.forEach((coupon) => {
            const newCoupon = {
              voucherCode: coupon.voucher_used,
              voucherValue: parseFloat(coupon.voucher_value, 10).toFixed(2),
              voucherPercent: false,
              voucherType: coupon.voucher_vtype,
              voucherTitle: coupon.voucher_vtype === voucherTypes.ancv ? formatMessage(messages.voucherAncv) : formatMessage(messages.voucherPasseCulture),
              voucherData: response.data,
              voucherName: coupon.voucher_name
            }
            if (coupon.voucher_vtype === voucherTypes.passculture) {
              this.setState({
                  showAddPassCulture: false
              });
            }

            if (voucherTypes.reduc != coupon.voucher_vtype) {
              this.setState({
                  couponsList: [...this.state.couponsList, newCoupon]
              });
            }

            if (voucherTypes.ancv === coupon.voucher_vtype) {
              this.setState({voucherAncv: true});
            }

            if (voucherTypes.passculture === coupon.voucher_vtype) {
              this.setState({voucherPassCulture: true});
            }
          });
        }

        self.showOrderDetails();

      })
      .catch(error => {
        console.log(error)
      })
  }

  getBookingInfo = (idOrder, tokenOrder) => {
    axios.get(buildAPI_URL_Booking(idOrder, tokenOrder))
      .then(response => {
      })
      .catch(error => console.log(error))
  }

  handleDelete = async (slot) => {
    const idReservation = slot.id
    const idReservationToken = this.findToken(parseInt(slot.id, 10))

    const body = {
      id_reservation: idReservation,
      token_reservation: idReservationToken
    }
    const url = `${API_ROOT}FrontDeleteRoomReservation.php`

    return await fetch(url, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
          },
      method: 'post',
      body: buildFormBody(body)
    })
    .then(response => response.json())
    .then(data => {
      const cookies = new Cookies()
      const bookings = cookies.get('bookings').filter(x => x.id !== slot.id)
      cookies.set('bookings', bookings, { path: '/', expires: new Date('2040-12-17T03:24:00') })
      this.setState({bookings: bookings});
      this.updateBookings();
      this.getOrderInfo();
    })
    .catch(error => console.log(error))
  }

  findToken = (id) => {
    const cookies = new Cookies()
    const bookings = cookies.get('bookings')
    if (bookings && bookings.length > 0) {
      for (let i = 0; i < bookings.length; i++) {
        if (parseInt(bookings[i].id) == id) {
          return bookings[i].id_room_reservation_token
        }
      }
      
    }
    if (cookies.get("bookingsTokens")) {
      return cookies.get("bookingsTokens").filter(x => x.id_room_reservation === id).shift().id_room_reservation_token
    }
    
  }

  getAllBookingsInfo = () => {
    this.state.bookings.forEach(x => {
      this.getBookingInfo(x.id_room_reservation, x.id_room_reservation_token)
    })
  }

  initUserIsPlaying = () => {
    this.state.bookings.forEach(x => {
      this.handleUserIsPlaying(x.id, false)
    })
  }

  handleUserIsPlaying = async (id, playing) => {
    let isPlaying = Object.assign({}, this.state.userIsPlaying)
    isPlaying[id] = playing
    this.setState({
      userIsPlaying: isPlaying
    })
    await window.setTimeout(() => {
      let test = null
    }, 20)
    this.userIsPlayerOne()
  }

  userIsPlayerOne = () => {
    Object.keys(this.state.userIsPlaying).map((booking) => {
      let isPlaying = this.state.userIsPlaying[booking]
      if (isPlaying) {
        this.handlePlayersEmail(booking, this.state.email, 1)
      }
    })
  }

  initPlayersEmail = () => {
    let emailForOrder = Object.assign({}, this.state.playersEmail)
    this.state.bookings.forEach(x => {
      emailForOrder[x.id] = {}
    })
    this.setState({playersEmail: emailForOrder})
  }

  handlePlayersEmail = (id, email, position) => {
    let emailForOrder = Object.assign({}, this.state.playersEmail)
    if (!emailForOrder[id])
      emailForOrder[id] = {};
    emailForOrder[id][position] = email
    this.setState({ playersEmail: emailForOrder })
  }

  handleIsCorporate = (forceChange, forceHide = false) => {
    let form = document.getElementById("cart-form-corporate")
    if (form) {
      if (this.state.userIsCorporate) {
        if (forceChange) {
          this.setState({ userIsCorporate: false });
        }
        setTimeout(() => {
          form.style.height = "0"
        }, 400)
        form.style.opacity = "0"
        form.style.visibility = "hidden"
      } else {
        if (forceChange) {
          this.setState({ userIsCorporate: true });
        }
        form.style.opacity = "1"
        form.style.height = "-moz-fit-content"
        form.style.height = "fit-content"
        form.style.visibility = "visible"
      }

      if (forceHide) {
        setTimeout(() => {
          form.style.height = "0"
        }, 400)
        form.style.opacity = "0"
        form.style.visibility = "hidden"
      }
    }
  }

  handleIsVoucherPromo = () => {
    this.setState({ voucherPromo: !this.state.voucherPromo });
    // if (this.state.voucherPromo) {
    //   const voucher = this.getCouponReduc();
    //   const cookies = new Cookies();
    //   const orderDetails = cookies.get("orderDetails");
    //   if (voucher && orderDetails && orderDetails.id_order_escape_token) {
    //     this.handleDeleteVoucher({id_voucher: voucher.voucherData.voucher_id, id_voucher_token: orderDetails.id_order_escape_token});
    //   }
    // }
  }

  handleIsVoucherAncv = () => {
    this.setState({ voucherAncv: !this.state.voucherAncv });
  }

  handleIsVoucherPassCulture = () => {
    this.setState({ voucherPassCulture: !this.state.voucherPassCulture });
  }

  buildEmailPlayers = () => {
    let emailArray = []
    Object.values(this.state.playersEmail).map((booking, i) => {
      let bookingArray = []
      for (let key in booking) {
        bookingArray.push(booking[key])
      }
      if (bookingArray.toString().replace(/,/g,';').length > 0) {
        emailArray.push(bookingArray.toString().replace(/,/g,';'))
      }
    })
    return emailArray
  }

  confirmOrder = async () => {
    const url = `${API_ROOT}FrontConfirmOrder.php`
    const cookies = new Cookies()
    const orderDetails = cookies.get("orderDetails")
    const emailArray = this.buildEmailPlayers()

    let body = {
      id_order: orderDetails.id_order_escape,
      token_order: orderDetails.id_order_escape_token,
      firstname: this.state.firstName,
      lastname: this.state.lastName,
      phone: this.state.telephone,
      email: this.state.email,
      comment: this.state.comment,
      is_company: this.state.userIsCorporate,
      company_name: this.state.companyName,
      address: this.state.companyAddress,
      postal_code: this.state.companyPostalCode,
      city: this.state.companyCity,
      multipayment_emails: JSON.stringify(this.state.multiPaymentEmails)
    }

    emailArray.forEach((x, i) => {
      const emailRef = `email_players-${this.state.bookings[i].id}`
      body[emailRef] = x.replace(/,/g,'')
    })

    return await fetch(url, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
          },
      method: 'post',
      body: buildFormBody(body)
    })
    .then(response => response.json())
    .then(data => {
      if (data && !data.result) {
        console.log(data.message);
      } else if (this.state.totalPriceDiscount === 0) {
        const lCookies = new Cookies()

        lCookies.set('orderDetails', '', { path: '/', expires: new Date('2040-12-17T03:24:00') });
        lCookies.set('bookings', '', { path: '/', expires: new Date('2040-12-17T03:24:00') });
        lCookies.set('bookingsTokens', '', { path: '/', expires: new Date('2040-12-17T03:24:00') });
        lCookies.set('orderDetailsVouchers', '', { path: '/', expires: new Date('2040-12-17T03:24:00') });
        lCookies.set('vouchers', '', { path: '/', expires: new Date('2040-12-17T03:24:00') });
        lCookies.set('cart_step', 0, { path: '/', expires: new Date('2040-12-17T03:24:00') });

        lCookies.remove("orderDetails")
        lCookies.remove("bookings")
        lCookies.remove("bookingsTokens")
        lCookies.remove("orderDetailsVouchers")
        lCookies.remove("vouchers")
        lCookies.remove("cart_step")

        this.props.history.push({
          pathname: "/confirmation",
          search: `?email=${this.state.email}&price=${this.state.totalPriceDiscount}`
        })
      } else {
        this.handlePaymentResponse(orderDetails.id_order_escape, orderDetails.id_order_escape_token);
      }
    })
    .catch(error => console.log(error))
  }

  confirmOnlyPayOrder = async () => {
    const url = `${API_ROOT}FrontOnlyPayOrder.php`
    const credentials = qs.parse(this.props.location.search.slice(1))
    let body = {
      id_order: credentials.id,
      token_order: credentials.token,
    }

    return await fetch(url, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
          },
      method: 'post',
      body: buildFormBody(body)
    })
    .then(response => response.json())
    .then(data => {
      this.handlePaymentResponse(credentials.id, credentials.token);
    })
    .catch(error => console.log(error))
  }

  buildRecipientAddress = () => {
    return `${this.state.recipientFirstName} ${this.state.recipientLastName}, ${this.state.recipientStreetAddress}, ${this.state.recipientPostalCode}, ${this.state.recipientCity}, ${this.state.recipientCountry}`
  }

  buildCommentWithAddress = () => {
    return `Commentaire : ${this.state.paperCardNote}. Adresse: ${this.buildRecipientAddress()}`
  }

  confirmOrderVoucher = async () => {
    const url = `${API_ROOT}FrontConfirmOrder.php`
    const cookies = new Cookies()
    const orderDetails = cookies.get("orderDetailsVouchers")
    const idVoucher = cookies.get("vouchers")[0].id_voucher
    const recipientAddressBuild = this.buildRecipientAddress()

    let body = {
      id_order: orderDetails.id_order_escape.toString(),
      token_order: orderDetails.id_order_escape_token,
      firstname: this.state.firstName,
      lastname: this.state.lastName,
      phone: this.state.telephone,
      email: this.state.email,
      is_company: false
    }

    if (this.state.vouchers[0].paper_card) {
      body[`address-${idVoucher}`] = recipientAddressBuild
      body[`comment-${idVoucher}`] = this.state.paperCardNote
      body['comment'] = this.buildCommentWithAddress()
    }

    return await fetch(url, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
          },
      method: 'post',
      body: buildFormBody(body)
    })
    .then(response => response.json())
    .then(data => {
      if (data && !data.result) {
        console.log(data.message);
      } else if (this.state.totalPriceDiscount === 0) {
        const lCookies = new Cookies()

        lCookies.set('orderDetails', '', { path: '/', expires: new Date('2040-12-17T03:24:00') });
        lCookies.set('bookings', '', { path: '/', expires: new Date('2040-12-17T03:24:00') });
        lCookies.set('bookingsTokens', '', { path: '/', expires: new Date('2040-12-17T03:24:00') });
        lCookies.set('orderDetailsVouchers', '', { path: '/', expires: new Date('2040-12-17T03:24:00') });
        lCookies.set('vouchers', '', { path: '/', expires: new Date('2040-12-17T03:24:00') });
        lCookies.set('cart_step', 0, { path: '/', expires: new Date('2040-12-17T03:24:00') });

        lCookies.remove("orderDetails")
        lCookies.remove("bookings")
        lCookies.remove("bookingsTokens")
        lCookies.remove("orderDetailsVouchers")
        lCookies.remove("vouchers")
        lCookies.remove("cart_step")

        this.props.history.push({
          pathname: "/confirmation",
          search: `?email=${this.state.email}&price=${this.state.totalPriceDiscount}`
        })
      } else {
        //this.handlePaymentResponse(data.data_content, data.seal_content)
        this.handlePaymentResponse(orderDetails.id_order_escape, orderDetails.id_order_escape_token);
      }
    })
    .catch((error) => {console.log(error);this.setState({ isInPayment: false });})
  }

  handlePaymentResponse = (id_order, token_order) => {
    console.log(id_order, token_order);
    const url = `${API_ROOT}Axepta.php`;
    fetch(url, {
      method: 'POST',
      headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
      },
      body: buildFormBody({ "id_order": id_order, "token_order": token_order }),
    })
      .then(response => response.json())
      .then(data => {
        if (data && data.result && data.html) {
          // Append the HTML to the body
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = data.html;
          document.body.appendChild(tempDiv);

          // Submit the form with id 'paymentForm'
          const paymentForm = document.getElementById('paymentForm');
          if (paymentForm) {
            paymentForm.submit();
          } else {
            console.error('Payment form not found.');
          }
        }
      })
      .catch(error => {
       console.error('Error during payment request:', error);
      });
  }

  handleDeleteVoucher = async (voucher) => {
    const url = `${API_ROOT}FrontDeleteVoucher.php`

    let body = {
      id_voucher: voucher.id_voucher.toString(),
      token_voucher: voucher.id_voucher_token
    }

    return await fetch(url, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
          },
      method: 'post',
      body: buildFormBody(body)
    })
    .then(response => response.json())
    .then(data => {
      const vouchers = this.state.vouchers.filter(x => x.id_voucher !== voucher.id_voucher)
      const cookies = new Cookies()
      cookies.set('vouchers', vouchers, { path: '/', expires: new Date('2040-12-17T03:24:00') })
      this.updateVouchers()
    })
    .catch(error => console.log(error))
  }

  getTotalPriceVouchers = (arr) => {
    const vouchers = arr
    let total = 0
    vouchers.forEach(x => {
      total = total + x.price
    })
    return total - this.state.couponCodeDiscount
  }

  handleRecipientInfo = async (data, id, category) => {
    const vouchers = this.state.vouchersByPostCard.filter(x => x.id_voucher !== id)
    const voucher = this.state.vouchersByPostCard.filter(x => x.id_voucher === id)[0]
    voucher[category] = data
    vouchers.push(voucher)
    await this.setState({ vouchersByPostCard: vouchers }, console.log(this.state.vouchersByPostCard))
    this.updateVouchers()
  }

  initVouchersByPostCard = async () => {
    const cookies = new Cookies()
    const vouchers = cookies.get("vouchers")
    let vouchersByPostCard = []
    vouchers.forEach((x, i) => {
      if (x.paper_card) {
        x["position"] = i + 1
        vouchersByPostCard.push(x)
      }
    })
    await this.setState({
      vouchersByPostCard: vouchersByPostCard,
    })
  }

  updateVouchers = async () => {
    const cookies = new Cookies()
    const vouchers = cookies.get("vouchers")
    const paperCard = vouchers.some(hasPaperCard)

    await this.setState({
      vouchers: vouchers,
      paperCard: paperCard,
      totalPrice: this.getTotalPriceVouchers(vouchers),
      totalPriceWithOptions: this.getTotalPriceVouchers(vouchers),
      totalPriceWithoutOptions: this.getTotalPriceVouchers(vouchers),
      totalPriceDiscount: this.getTotalPriceVouchers(vouchers)
    })

    if (this.state.vouchers < 1) {
      this.props.history.push({
        pathname: "/carte-cadeaux"
      })
    }
  }

  changeStatus = (newStep) => {
    this.setState({status: newStep});
    const cookies = new Cookies();
    const date = new Date();
    date.setDate(date.getDate() + 1)
    cookies.set('cart_step', newStep, { path: '/', expires: date })
  }

  recoverStatus = async () => {
    const cookies = new Cookies();
    const cartStep = cookies.get('cart_step');
    if (!(cartStep === undefined)) {
      await this.setState({status: parseInt(cartStep)});
    }
  }

  async componentDidMount() {
    const cookies = new Cookies()
    if (this.props.location.search && (this.props.location.search !== "?new" || this.props.location.search !== "?id=")) {
      const credentials = qs.parse(this.props.location.search.slice(1))
      await this.getOrderInfoFromURLQuery(credentials.id, credentials.token)
    } else if (cookies.get("bookings") && cookies.get("bookings") != 'null' &&  this.props.location.state && this.props.location.state.new) {
      await this.updateBookings()
      this.props.expiracy
    } else if (cookies.get("bookings") && cookies.get("bookings") != 'null' && cookies.get("bookings").length > 0) {
      await this.updateBookings()
      await this.getOrderInfo()
    } else if (cookies.get("vouchers") && cookies.get("vouchers") != 'null') {
      this.initVouchersByPostCard()
      await this.updateVouchers()
      await this.getOrderInfo()
    } else {
      // this.props.history.push({
      //   pathname: "/reserver"
      // })
    }

    this.initUserIsPlaying()
    this.initPlayersEmail()
    this.showOrderDetails();
    this.recoverStatus();
    this.handleIsCorporate(false, true);
    this.updateMultipaymentSlots();
  }

  componentDidUpdate() {

  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  handleAutoFill = (e) => {
    if (e.animationName === 'onAutoFillStart' && e.target.tagName === 'INPUT') {
      const { name, value } = e.target;
      // appelle le même onChange que tes <Field/>
      try {
        this.setState({ [this.fieldStateKey(name)]: value });
      } catch(e) {
        
      }
    }
  }

  generateTitle = (title, step, disabled = true) => {
    if (disabled) {
      const {intl:{formatMessage}} = this.props;

      return <div class="cart-title-disabled-block">
                  <div className="cart-title-disabled">
                    {title}
                  </div>
                  {!this.state.onlyPayment || (this.state.onlyPayment && step != -1) ? <div className="cart-title-modify"><a onClick={() => this.changeStatus(step)}>{formatMessage(messages.modify)}</a></div> : ""}
                </div>;
    } else {
      return <div className="cart-title">
                  {title}
                </div>;
    }
  };

  getCouponReduc = () =>{
    let r = null;
    this.state.couponsList.forEach((coupon) => {
      if (voucherTypes.reduc == coupon.voucherType) {
        r = coupon;
      }
    });

    return r;
  };

  getCouponAncv = () =>{
    let r = {value: 0};
    this.state.couponsList.forEach((coupon) => {
      if (voucherTypes.ancv != coupon.voucherType) {
        r.value += coupon.voucher_value;
      }
    });

    return r;
  };

  getCouponPassCulture = () =>{
    let r = {value: 0};
    this.state.couponsList.forEach((coupon) => {
      if (voucherTypes.passculture != coupon.voucherType) {
        r.value += coupon.voucher_value;
      }
    });

    return r;
  };

  updateMultipaymentSlots = () => {
    let maxMultiPaymentEmails = 0;
    this.state.bookings.forEach((booking) => {
      maxMultiPaymentEmails += parseInt(booking.quantity_player);
    });
    this.setState({ maxMultiPaymentEmails: maxMultiPaymentEmails });
  };

  changeMasterEmail = (email) => {
    if (email) {
      let multiPaymentEmails = this.state.multiPaymentEmails;
      if (!multiPaymentEmails) multiPaymentEmails = [];
      multiPaymentEmails[0] = email;
      this.setState({ email: email, multiPaymentEmails: multiPaymentEmails });
    }
  }

  multipaymentActivated = () => {
    
    const currentTime = new Date();
    const limitTime = new Date(currentTime.getTime() + this.state.multiPaymentLimit * 60 * 60 * 1000);

    if (this.state.totalPriceDiscount == 0 || this.state.bookings.some(booking => new Date(booking.reservation_date + " " + booking.time_begin) < limitTime)) {
      return false;
    }

    return true;
  }

  changeMultipayment = async (enable = false) => {
    if (!this.multipaymentActivated()) {
      return;
    }
    if (enable && !this.validateForm()) {
      this.setState({ formIsValid: false }, smoothscroll(document.getElementById("cart-summary-error-anchor")))
      return;
    }
    this.setState({ multiPaymentLoader: true});
    const url = `${API_ROOT}FrontChangeMultipayment.php`
    const { intl: { formatMessage } } = this.props
    const cookies = new Cookies()
    let orderDetails
    if (cookies.get("vouchers") && cookies.get("vouchers") != 'null') {
      orderDetails = cookies.get("orderDetailsVouchers")
    } else {
      orderDetails = cookies.get("orderDetails")
    }
    const idOrder = orderDetails.id_order_escape
    const tokenOrder = orderDetails.id_order_escape_token
    
    const body = {
      id_order: idOrder,
      token_order: tokenOrder,
      multipayment: enable
    }

    const emails = this.buildEmailPlayers();
    const masterEmail = this.state.email;
    if (emails && emails.length > 0) {
      const primaryEmails = emails[0].split(";");
      const multiPaymentEmails = [];
      if (this.state.email) {
        multiPaymentEmails.push(masterEmail);
      }
      primaryEmails.forEach((email) => {
        if (email && email.length > 0 && multiPaymentEmails.indexOf(email) == -1) {
          multiPaymentEmails.push(email);
        }
      });
      this.setState({ multiPaymentEmails: multiPaymentEmails });
    }

    this.updateMultipaymentSlots();

    return await fetch(url, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      method: 'post',
      body: buildFormBody(body)
    })
      .then(response => response.json())
      .then(data => {
        if (data.result) {
          this.getOrderInfo(() => {
            this.setState({ multiPayment: enable, multiPaymentLoader: false, multiPaymentFee: data.multipayment_fee });  
          });
        } else {
          this.setState({ multiPayment: !enable, multiPaymentLoader: false });
        }
      })
      .catch(error => console.log(error))
  };

  addMultiPaymentEmailField = () => {
    if (!this.state.multiPaymentEmails || this.state.multiPaymentEmails.length >= this.state.maxMultiPaymentEmails) return;
    this.setState((prevState) => ({
      multiPaymentEmails: [...prevState.multiPaymentEmails, ""]
    }))
  };

  removeMultiPaymentEmailField = (index) => {
    if (index === 0) return; // empêche la suppression du 1er
    this.setState((prevState) => {
      const newEmails = [...prevState.multiPaymentEmails]
      newEmails.splice(index, 1)
      return { multiPaymentEmails: newEmails }
    })
  };

  handleMultiPaymentEmailChange = (index, value) => {
    const updatedEmails = [...this.state.multiPaymentEmails]
    updatedEmails[index] = value
    this.setState({ multiPaymentEmails: updatedEmails })
  };

  getMultiPaymentAmountPerPlayer = () => {
    const amountPerPlayer = this.state.totalPriceDiscount / this.state.multiPaymentEmails.length;
    return parseFloat(Math.ceil(amountPerPlayer * 100) / 100).toFixed(2);
  };

  render() {
    const {intl:{formatMessage}} = this.props
    const bookingCheckout = this.state.bookings.length > 0

    let r = "";
    // Total (bottom purple)
    const groupCoupons = () => {
      let val = [];
      let gr = {};
      this.state.couponsList.map((coupon, i) => {
        if (!gr[coupon.voucherType]) {
          gr[coupon.voucherType] = {title: coupon.voucherTitle, value: coupon.voucherValue ? parseFloat(coupon.voucherValue) : 0, percent: coupon.voucherPercent}
        } else {
          if (coupon.voucherValue) {
            gr[coupon.voucherType].value += parseFloat(coupon.voucherValue);  
          }
        }
      });

      Object.keys(gr).forEach((key) => {
        val.push(<div class="cart-total-in-line"><div>{voucherTypes.reduc === key ? gr[key].title + " " + this.state.couponCode : gr[key].title} </div><div className="cart-total-in-line-voucher">-&nbsp;{Math.floor(gr[key].value)},{(Math.round((gr[key].value % 1) * 100) / 100).toFixed(2).split(".")[1] + (gr[key].percent ? " %" : " €")}</div></div>);
      });

      return val;
    };

    const hasNoDiscount = this.getCouponReduc() || !bookingCheckout;
    const cartTotal = <div class={"cart-total" + (this.state.cartTotalOpened ? " cart-total-opened cart-total-opened-animation" : "")} onClick={() => this.toggleCartTotalOpened()}>
                  <div class="cart-total-top-line">
                    {formatMessage(messages.summaryTitle)}
                  </div>
                  <div class="cart-total-top-line-mobile">
                    <div><i class={"arrow " + (this.state.cartTotalOpened ? "down" : "up")}></i> {formatMessage(messages.totalCart)}</div>
                    <div class="cart-total-top-line-main-price">{(this.state.cartTotalOpened ? (Math.floor(this.state.totalPrice) + "," + (Math.round((this.state.totalPrice % 1) * 100) / 100).toFixed(2).split(".")[1]) : (Math.floor(this.state.totalPriceDiscount) + "," + (Math.round((this.state.totalPriceDiscount % 1) * 100) / 100).toFixed(2).split(".")[1])) } €</div>
                  </div>
                  {
                      <React.Fragment>
                        <div className={this.state.cartTotalOpened ? "cart-displayed" : "cart-hidden"}>
                          <div class="cart-total-break"></div>
                          <div class="cart-total-line"></div>
                          <div class="cart-total-in-line">
                            <div>{bookingCheckout ? formatMessage(messages.games) : formatMessage(messages.giftCard) } : </div><div>{Math.floor(this.state.totalPrice)},{(Math.round((this.state.totalPrice % 1) * 100) / 100).toFixed(2).split(".")[1]} €</div>
                          </div>
                          <div class={"cart-total-in-line" + (this.state.totalOptions > 0 ? "" : " hidden")}>
                            <div>{formatMessage(messages.options)} : </div><div>{Math.floor(this.state.totalOptions)},{(Math.round((this.state.totalOptions % 1) * 100) / 100).toFixed(2).split(".")[1]} €</div>
                          </div>
                          <div class={"cart-total-in-line" + (this.state.couponsList.length > 0 ? "" : " hidden")}>
                            <div>{formatMessage(messages.discount)} : </div>
                          </div>
                          {groupCoupons()}
            {this.state.multiPayment && this.state.multiPaymentFee > 0 ? 
                          <div class="cart-total-in-line">
                            <div> {formatMessage(messages.multiPaymentOption) } : </div><div>{this.state.multiPaymentFee} €</div>
                          </div> : null}
                          <div class="cart-total-line cart-total-line-last"></div>
                          <div class="cart-total-bottom-line">
                            <div>{formatMessage(messages.totalCart)} :</div>
                            <div class="cart-total-top-line-main-price">{(Math.floor(this.state.totalPriceDiscount) + "," + (Math.round((this.state.totalPriceDiscount % 1) * 100) / 100).toFixed(2).split(".")[1]) } €</div>
                          </div>
                        </div>
                      </React.Fragment>
                 } 
                </div>;

    const multiPaymentAcceptTerms = formatMessage(messages.multiPaymentAcceptTerms);

    // Content
    if (status.step1 === this.state.status) {
      r = (
        <div id="cart-summary" className="cart-summary">
                {this.generateTitle("1 " + formatMessage(messages.cart), status.step1, false)}
                <div className="cart-headline">
                  {formatMessage(messages.cartHeadlineCart)}
                </div>
                <div className="cart-items-collapsible-line cart-items-collapsible-line-top-desktop"></div>
                <div className="cart-items-collapsible-container">
                  <div className="cart-items-collapsible" id="order-details">
                  {
                    bookingCheckout
                    ?
                      Object.keys(this.state.bookings).map((x, i) =>
                        <CartItem
                          key={`cart-item-${i}`}
                          slot={this.state.bookings[x]}
                          lang={this.props.lang}
                          handleDelete={(slot) => this.handleDelete(slot)}
                          updateBookings={(booking) => this.updateNewBookings(booking)}
                          deletable={true}
                          locked={this.props.location.search ? true : false}
                        />
                      )
                    :
                     Object.keys(this.state.vouchers).map((x, i) =>
                      <CartItemVoucher
                        key={`cart-item-voucher-${i}`}
                        id={i}
                        single={this.state.vouchers.length === 1}
                        voucher={this.state.vouchers[x]}
                        handleDelete={(voucher) => this.handleDeleteVoucher(voucher)}
                      />
                    )
                  }
                  </div>
                  <div className="cart-summary-coupon-total-price--mobile">
                    <p>{formatMessage(messages.totalCart)}</p>
                    <h3>{Math.floor(this.state.totalPriceWithOptions)},{(Math.round((this.state.totalPriceWithOptions % 1) * 100) / 100).toFixed(2).split(".")[1]} €</h3>
                  </div>
          <div className={"cart-item-new" + (bookingCheckout ? "" : " hidden")}>
            <Link to="/reserver">
              <p>{formatMessage(messages.reservationNew)}</p>
            </Link>
          </div>
                </div>
                <a className="cart-items-collapsible-bottom" onClick={() => this.changeStatus(status.step2)}><div id="booking-cta"><div className={"learn-more themes-cart-cta cart-button" + (!bookingCheckout ? " cart-button-voucher" : "")}><span data-text="{formatMessage(messages.next)}">{formatMessage(messages.confirm)}</span></div></div></a>
                <div class="cart-end-section"></div>
                <div class="cart-title-disabled cart-summary-section">
                  2 {formatMessage(messages.voucher)}
                </div>
                <div class="cart-end-section"></div>
                <div class="cart-title-disabled cart-summary-section">
                  3 {formatMessage(messages.information)}
                </div>
              </div>
        )
    } else if (status.step2 === this.state.status) {
      r = (
          <div id="cart-summary" className="cart-summary">
                <div className={"voucher-loader-layer" + (this.state.showVoucherPaymentOverlay ? "" : " hidden")}>{formatMessage(messages.smartphonePayment)}<br /> <br/><svg fill="#FFFFFF" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M7,1A2,2,0,0,0,5,3V21a2,2,0,0,0,2,2H17a2,2,0,0,0,2-2V3a2,2,0,0,0-2-2ZM17,21H7V3H9.5L10,4h4l.5-1H17Z"/></svg><br /><div className="cart-form-send-to-players-button ancv-cancel-button" onClick={() => this.handleAncvCancel()}>{formatMessage(messages.cancel)}</div></div>
                {this.generateTitle("1 " + formatMessage(messages.cart), status.step1, true)}
                <div>
                  {
                    bookingCheckout
                    ?
                      Object.keys(this.state.bookings).map((x, i) =>
                        <CartItem
                          key={`cart-item-${i}`}
                          slot={this.state.bookings[x]}
                          lang={this.props.lang}
                          readOnly={true}
                        />
                      )
                    :
                     Object.keys(this.state.vouchers).map((x, i) =>
                      <CartItemVoucher
                        key={`cart-item-voucher-${i}`}
                        id={i}
                        single={this.state.vouchers.length === 1}
                        voucher={this.state.vouchers[x]}
                        readOnly={true}
                        handleDelete={(voucher) => this.handleDeleteVoucher(voucher)}
                      />
                    )
                  }
                </div>
                <div class="cart-end-section"></div>
                {this.generateTitle("2 " + formatMessage(messages.voucher), status.step2, false)}
                <div className="cart-headline">
                  {formatMessage(messages.cartHeadlineVoucher)}
                  
                  <div className="cart-voucher-elements">
                    <div className={"cart-voucher-element cart-summary-coupon cart-summary-coupon--mobile" + (this.state.voucherPromo ? " cart-form-selected" : "") + (bookingCheckout ? "" : " hidden")}>
                       <div
                          className="cart-form-checkbox cart-form-checkbox--checked"
                          onChange={() => this.handleIsVoucherPromo()}>
                          <label><input type="checkbox" className="cart-form-check cart-voucher-element-checkbox" checked={this.state.voucherPromo ? "checked" : ""}></input><span class="checkmark"></span>{formatMessage(messages.voucherCheckbox)}</label>

                        </div>
                        <div className={"cart-in-field" + (this.state.voucherPromo ? "" : " hidden")}>
                            <input type="text" placeholder={formatMessage(messages.couponCodeAdd)}
                              value={this.state.couponCode}
                              disabled={this.getCouponReduc()}
                              onChange={(e) => this.setState({ couponCode: e.target.value })} />
                            <button disabled={this.getCouponReduc()} onClick={() => this.handleCouponCode(this.state.couponCode, voucherTypes.reduc)}>{formatMessage(messages.couponCodeApply)}</button>
                        </div>
                        <div className={"cart-in-error-message" + (this.state.hasCouponCode && !this.state.hasValidCouponCode ? "" : " hidden")}>
                        {
                          this.state.hasCouponCode && !this.state.hasValidCouponCode
                          ? <p className="cart-summary-coupon--invalid-message cart-summary-coupon--invalid-message--mobile">{formatMessage(messages.couponCodeError) + " : " + this.state.voucherMessage}</p>
                          : null
                        }
                        </div>
                        <div className={"cart-voucher-resume" + (this.state.voucherPromo ? "" : " hidden")}>
                          <p>{this.getCouponReduc() ? this.getCouponReduc().voucherCode + " : " : ""} 
                            {
                              Object.keys(this.getCouponsList(voucherTypes.reduc)).map((x, i) => 
                                (
                                  this.getCouponsList(voucherTypes.reduc)[i].voucherPercent ?
                                  <span className="cart-voucher-resume-item">- {Math.floor(this.getCouponsList(voucherTypes.reduc)[i].voucherValue)} %</span>
                                  :
                                  <span className="cart-voucher-resume-item">- {Math.floor(this.getCouponsList(voucherTypes.reduc)[i].voucherValue)},{(Math.round((this.getCouponsList(voucherTypes.reduc)[i].voucherValue % 1) * 100) / 100).toFixed(2).split(".")[1]} €</span>
                                )
                              )
                            }
                          </p>
                        </div>
                    </div>
     
                    <div id="ancv-block" className={"cart-voucher-element cart-summary-coupon cart-summary-coupon--mobile" + (this.state.voucherAncv ? " cart-form-selected" : "")}>
                       <div
                          className="cart-form-checkbox cart-form-checkbox--checked cart-form-checkbox-ancv"
                          onChange={() => this.handleIsVoucherAncv()}>
                          <label><input type="checkbox" className="cart-form-check cart-voucher-element-checkbox" checked={this.state.voucherAncv || this.getCouponAncv().value > 0 ? "checked" : ""}></input><span class="checkmark"></span><img src={AncvIcon} className="ancvLogo" /><span class="ancv-title">{formatMessage(messages.ancvCheckbox)}</span></label>

                        </div>
                        <div className={"ancv-warning" + (this.state.voucherAncv ? "" : " hidden")}>{formatMessage(messages.ancvWarning)}</div>
                        <div className={"cart-in-field" + (this.state.voucherAncv ? "" : " hidden")}>
                            <input type="text" placeholder={formatMessage(messages.couponAncvIdentifier)}
                              disabled={this.getCouponsList(voucherTypes.ancv).length > 0 || this.state.showVoucherPaymentOverlay}
                              onChange={(e) => this.setState({ ancvIdentifier: e.target.value })} />
                            <button onClick={() => this.handleAncv(this.state.ancvIdentifier)} disabled={this.getCouponsList(voucherTypes.ancv).length > 0 || this.state.showVoucherPaymentOverlay}>{formatMessage(messages.couponCodeApply)}</button>
                        </div>
                        <div className={"cart-in-error-message" + (this.state.voucherAncv && this.state.ancvError ? "" : " hidden")}>
                        {
                          this.state.ancvError
                          ? <p className="cart-summary-coupon--invalid-message cart-summary-coupon--invalid-message--mobile cart-summary-coupon--invalid-message--mobile-ancv"><br/>⚠️ {this.state.ancvError}</p>
                          : null
                        }
                        </div>
                    </div>
                    <div id="passculture-block" className={"cart-voucher-element cart-summary-coupon cart-summary-coupon--mobile" + (this.state.voucherPassCulture ? " cart-form-selected" : "")}>
                       <div
                          className="cart-form-checkbox cart-form-checkbox--checked cart-form-checkbox-passculture"
                          onChange={() => this.handleIsVoucherPassCulture()}>
                          <label><input type="checkbox" className="cart-form-check cart-voucher-element-checkbox" checked={this.state.voucherPassCulture || this.getCouponPassCulture().value > 0 ? "checked" : ""}></input><span class="checkmark"></span><img src={PassCultureIcon} className="passCultureLogo" /><span class="ancv-title">{formatMessage(messages.passcultureCheckbox)}</span></label>

                        </div>
                        <div className={"passculture-block-headline" + (this.state.voucherPassCulture ? "" : " hidden")}>{formatMessage(messages.headlinePassCulture)} <a href="/pass-culture-escape-game-paris/#comment-utiliser-le-pass-culture" target="_blank">Pass Culture</a> !</div>
                        {
                        Object.keys(this.getCouponsList(voucherTypes.passculture)).map((x, i) =>
                              <div className={"cart-in-field" + (this.state.voucherPassCulture ? "" : " hidden")}>
                                <input type="text" placeholder={formatMessage(messages.couponPassCultureReservation)}
                                  disabled={this.getCouponsList(voucherTypes.passculture).length > 0}
                                  onChange={(e) => this.setState({ passCultureReservation: e.target.value })}
                                  value={this.getCouponsList(voucherTypes.passculture)[x].voucherName} />
                                <button onClick={() => this.handlePassCulture(this.state.passCultureReservation)} disabled={this.getCouponsList(voucherTypes.passculture).length > 0 || this.state.showVoucherPaymentOverlay}>{formatMessage(messages.couponCodeApply)}</button>
                            </div>
                            )
                        }

                        <div className={"cart-in-field" + (this.state.voucherPassCulture && this.state.showAddPassCulture ? "" : " hidden")}>
                            <input type="text" id="currentPassCulture" placeholder={formatMessage(messages.couponPassCultureReservation)}
                              onChange={(e) => this.setState({ passCultureReservation: e.target.value })}  />
                            <button onClick={() => this.handlePassCulture(this.state.passCultureReservation)}>{formatMessage(messages.couponCodeApply)}</button>
                        </div>
                        

                        <div className={"pass-culture-success" + (this.state.showSuccessPassCulture ? "" : " hidden")}>
                          {formatMessage(messages.successPassCulture)}
                        </div>
                        <div className={"cart-title-modify pass-culture-plus" + (this.state.voucherPassCulture ? "" : " hidden")}>
                          <a onClick={(e) => {this.setState({ showAddPassCulture: true }); document.getElementById("currentPassCulture").value = '';}}><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="8" r="7.5" stroke="#0565BE"/><path d="M12 7.43902H8.56098V4H7.43902V7.43902H4V8.56098H7.43902V12H8.56098V8.56098H12V7.43902Z" fill="#0565BE"/></svg>
                               {formatMessage(messages.addPassCulture)}</a>
                        </div>
                        <div className={"cart-in-error-message" + (this.state.voucherPassCulture && this.state.passCultureError ? "" : " hidden")}>
                        {
                          this.state.passCultureError
                          ? <p className="cart-summary-coupon--invalid-message cart-summary-coupon--invalid-message--mobile"><br/>{this.state.passCultureError}</p>
                          : null
                        }
                        </div>
                    </div>
                    <a onClick={() => this.changeStatus(status.step3)}><div id="booking-cta"><div class="learn-more themes-cart-cta cart-button"><span data-text="{formatMessage(messages.confirm)}">{hasNoDiscount ? formatMessage(messages.next) : formatMessage(messages.noDiscount)}</span></div></div></a>
                  </div>
                  

                </div>
                <div class="cart-end-section"></div>
                <div class="cart-title-disabled cart-summary-section">
                  3 {formatMessage(messages.information)}
                </div>
          </div>
          )
    } else if (status.step3 === this.state.status) {
      r = (
          <div id="cart-summary" className="cart-summary">
                {this.generateTitle("1 " + formatMessage(messages.cart), status.step1, true)}
                <div>
                {
                    bookingCheckout
                    ?
                      Object.keys(this.state.bookings).map((x, i) =>
                        <CartItem
                          key={`cart-item-${i}`}
                          slot={this.state.bookings[x]}
                          lang={this.props.lang}
                          readOnly={true}
                        />
                      )
                    :
                     Object.keys(this.state.vouchers).map((x, i) =>
                      <CartItemVoucher
                        key={`cart-item-voucher-${i}`}
                        id={i}
                        single={this.state.vouchers.length === 1}
                        voucher={this.state.vouchers[x]}
                        readOnly={true}
                        handleDelete={(voucher) => this.handleDeleteVoucher(voucher)}
                      />
                    )
                  }
                </div>
                <div class="cart-end-section"></div>
                {this.generateTitle("2 " + formatMessage(messages.voucher), status.step2, true)}
                <div>
                <div className="cart-voucher-resume cart-item-readonly-element">
                  <p>
                    {
                      Object.keys(this.state.couponsList).map((x, i) => 
                        (
                            this.state.couponsList[i].voucherPercent ?
                            <span className="cart-voucher-resume-item no-bold ">{this.state.couponsList[i].voucherTitle + " : - " + Math.floor(this.state.couponsList[i].voucherValue)} %<br/></span>
                            :
                            <span className="cart-voucher-resume-item no-bold ">{this.state.couponsList[i].voucherTitle + " : - " + Math.floor(this.state.couponsList[i].voucherValue)},{(Math.round((this.state.couponsList[i].voucherValue % 1) * 100) / 100).toFixed(2).split(".")[1]} €<br/></span>
                          
                        )
                      )
                    }
                  </p>
                </div>



                </div>
                <div class="cart-end-section"></div>
                <div className="cart-title">
                  3 {formatMessage(messages.information)}
                </div>
                <div className="cart-form-title cart-headline">
                  <p id="cart-summary-error-anchor">{formatMessage(messages.customerInformation)}</p>
                  <p className="mandatory">{formatMessage(messages.mandatoryFields)}</p>
                  {
                    !this.state.formIsValid
                    ?
                      <div className="cart-summary-error cart-summary-section">
                        <p>{formatMessage(messages.informationError)}</p>
                      </div>
                    : null
                  }
                </div>
                <form className="cart-form-fields-container" autoComplete="on" onAnimationStart={this.handleAutoFill}>
                  <div className="cart-form-fields-row">
                    <Field
                      name="fname"
                      placeholder={formatMessage(messages.informationFirstName) + "*"}
                      onChange={(data) => this.setState({ firstName: data})}
                      input={this.state.firstName} />
                    <Field
                      name="lname"
                      placeholder={formatMessage(messages.informationLastName) + "*"}
                      onChange={(data) => this.setState({ lastName: data})} 
                      input={this.state.lastName} />
                  </div>
                  {
                    bookingCheckout
                      ?
                      <div>
                        <div
                          className={ this.state.userIsCorporate ? "cart-form-checkbox cart-form-information-checkbox cart-form-checkbox--checked" : "cart-form-checkbox cart-form-information-checkbox"}
                          checked={this.state.userIsCorporate}
                          onChange={() => this.handleIsCorporate(true)}> 
                          <label><input type="checkbox" className="cart-form-check cart-voucher-element-checkbox" checked={this.state.userIsCorporate ? "checked" : ""}></input><span class="checkmark cart-form-corporate-checkmark"></span>{formatMessage(messages.informationIsCorporate)}</label>
                        </div>
                      </div>
                      : null
                  }
                  <div className="cart-form-corporate" id="cart-form-corporate">
                    <p>{formatMessage(messages.companyInformation)}</p>
                    <div className="cart-form-fields-row">
                      <Field
                        name="company_name"
                        placeholder={formatMessage(messages.informationCompanyName)}
                        onChange={(data) => this.setState({ companyName: data})}
                        input={this.state.companyName} />
                      <Field
                        name="address"
                        placeholder={formatMessage(messages.informationCompanyAddress)}
                        onChange={(data) => this.setState({ companyAddress: data})}
                         input={this.state.companyAddress} />
                    </div>
                    <div className="cart-form-fields-row">
                      <Field
                        name="postal_code"
                        placeholder={formatMessage(messages.informationCompanyPostalCode)}
                        onChange={(data) => this.setState({ companyPostalCode: data})}
                        input={this.state.companyPostalCode} />
                      <Field
                        name="city"
                        placeholder={formatMessage(messages.informationCompanyCity)}
                        onChange={(data) => this.setState({ companyCity: data})}
                         input={this.state.companyCity} />
                    </div>
                  </div>
                  <div className="cart-form-fields-row">
                    <Field
                      name="phone"
                      placeholder={formatMessage(messages.informationPhone) + "*"}
                      onChange={(data) => this.setState({ telephone: data})}
                      input={this.state.telephone} />
                    <Field
                      name="email"
                      id="customer-email"
                      placeholder={formatMessage(messages.informationEmail) + "*"}
                      onChange={(data) => this.changeMasterEmail(data)}
                      email 
                      input={this.state.email} />
                  </div>
                  {
                    bookingCheckout
                      ?
                      <div>
                        <Field textarea
                          placeholder={formatMessage(messages.informationComment)}
                          onChange={(data) => this.setState({ comment: data})}
                          input={this.state.comment} />
                      </div>
                      : null
                  }
                  {
                    this.state.paperCard
                    ?
                      <div className="cart-form-title">
                        <h2>{formatMessage(messages.informationReceiver)}</h2>
                        {
                          !this.state.formIsValidRecipient
                          ?
                            <div className="cart-summary-error cart-summary-section">
                              <p>{formatMessage(messages.informationError)}</p>
                            </div>
                          : null
                        }
                      </div>
                    : null
                  }
                  {
                    this.state.paperCard
                    ?
                      Object.keys(this.state.vouchersByPostCard).map((x, i) =>
                        <div key={`paper-card-recipient-${i}`}>
                          <div className="cart-form-title">
                            <h2>{this.state.vouchers.length === 1 ? formatMessage(messages.giftCard) : `${formatMessage(messages.giftCard)} #${this.state.vouchersByPostCard[x].position}`}</h2>
                            <p>{formatMessage(messages.informationGiftCardReceiver)}</p>
                          </div>
                          <div className="cart-form-fields-row">
                            <Field
                              name="fname"
                              placeholder={formatMessage(messages.informationFirstName) + "*"}
                              onChange={(data) => this.setState({ recipientFirstName: data })}
                              input={this.state.recipientFirstName} />
                            <Field
                              name="lname"
                              placeholder={formatMessage(messages.informationLastName) + "*"}
                              onChange={(data) => this.setState({ recipientLastName: data })}
                               input={this.state.recipientLastName} />
                          </div>
                          <div className="cart-form-fields-row">
                            <Field
                              name="address"
                              placeholder={formatMessage(messages.informationCompanyAddress) + "*"}
                              onChange={(data) => this.setState({ recipientStreetAddress: data })}
                              input={this.state.recipientStreetAddress} />
                            <Field
                              name="postal"
                              placeholder={formatMessage(messages.informationCompanyPostalCode) + "*"}
                              onChange={(data) => this.setState({ recipientPostalCode: data })}
                               input={this.state.recipientPostalCode} />
                          </div>
                          <div className="cart-form-fields-row">
                            <Field
                              name="city"
                              placeholder={formatMessage(messages.informationCompanyCity) + "*"}
                              onChange={(data) => this.setState({ recipientCity: data })}
                              input={this.state.recipientCity} />
                            <Field
                              name="country"
                              placeholder={formatMessage(messages.informationCountry) + "*"}
                              onChange={(data) => this.setState({ recipientCountry: data })}
                               input={this.state.recipientCountry} />
                          </div>
                          <div className="cart-form-fields-row">
                            <Field textarea
                              placeholder={formatMessage(messages.informationPaperCardNote)}
                              onChange={(data) => this.setState({ paperCardNote: data})}
                              input={this.state.paperCardNote} />
                          </div>
                        </div>
                      )
                    : null
                  }
                </form>
                {
                  bookingCheckout
                  ?
                  <div
                    id="send-to-players-button"
                    className="cart-form-send-to-players-button"
                    onClick={() => this.toggleSendToPlayers()}
                    >
                    <span>{formatMessage(messages.informationSendToPlayers)}</span>
                  </div>
                  : null
                }
                <div
                  className={this.state.sendToPlayers ? "cart-form-send-to-players" : "cart-form-send-to-players cart-form-send-to-players--hide"}
                  style={{opacity: this.state.playersFormOpacity}}
                  >
                  {
                    bookingCheckout
                    ?
                      Object.keys(this.state.bookings).map((x, i) =>
                        <div key={`playersEmail-${i}`}>
                          <div>
                            <h2>{themeCodeConverter(this.state.bookings[x].room_id)}</h2>
                            <p><b>{formatMessage(messages.informationSendToPlayersDate)} : </b>{createDate(this.state.bookings[x])}</p>
                          </div>
                          <div
                            className="cart-form-checkbox"
                            style={{ marginBottom: "17px"}}
                            >
                            <label><input type="checkbox"
                                className="cart-form-check"
                                checked={this.state.userIsPlaying[this.state.bookings[x].id]}
                                onChange={() => this.handleUserIsPlaying(this.state.bookings[x].id, !this.state.userIsPlaying[this.state.bookings[x].id])} className="cart-form-check cart-voucher-element-checkbox"></input><span class="checkmark cart-form-corporate-checkmark"></span>{formatMessage(messages.informationSendToPlayersUserIsPlaying)}</label>
                          </div>
                          <p style={{ marginBottom: "30px"}}>{formatMessage(messages.informationSendToPlayersEmails)} :</p>

                          <div className="cart-form-fields-row">
                            <Field
                              id={`email-player-1--booking-${i}`}
                              name="email"
                              placeholder={formatMessage(messages.informationPlayerEmail1)}
                              onChange={(data) => this.handlePlayersEmail(this.state.bookings[x].id, data, 1)}
                              email
                              input={this.state.userIsPlaying[this.state.bookings[x].id] && this.state.playersEmail[this.state.bookings[x].id] ? this.state.playersEmail[this.state.bookings[x].id][1] :  null}
                              />
                            <Field
                              id={`email-player-2--booking-${i}`}
                              name="email"
                              placeholder={formatMessage(messages.informationPlayerEmail2)}
                              onChange={(data) => this.handlePlayersEmail(this.state.bookings[x].id, data, 2)}
                              email />
                          </div>
                          <div className="cart-form-fields-row">
                            <Field
                              id={`email-player-3--booking-${i}`}
                              name="email"
                              placeholder={formatMessage(messages.informationPlayerEmail3)}
                              onChange={(data) => this.handlePlayersEmail(this.state.bookings[x].id, data, 3)}
                              email />
                            <Field
                              id={`email-player-4--booking-${i}`}
                              name="email"
                              placeholder={formatMessage(messages.informationPlayerEmail4)}
                              onChange={(data) => this.handlePlayersEmail(this.state.bookings[x].id, data, 4)}
                              email />
                          </div>
                          
                          <div className="cart-form-fields-row">
                            {this.state.bookings[x].quantity_player > 4 ?
                            <Field
                              id={`email-player-5--booking-${i}`}
                              name="email"
                              placeholder={formatMessage(messages.informationPlayerEmail5)}
                              onChange={(data) => this.handlePlayersEmail(this.state.bookings[x].id, data, 5)}
                              email />
                                :
                                ""
                            } 
                            {this.state.bookings[x].quantity_player > 5 ?
                            <Field
                              id={`email-player-6--booking-${i}`}
                              name="email"
                              placeholder={formatMessage(messages.informationPlayerEmail6)}
                              onChange={(data) => this.handlePlayersEmail(this.state.bookings[x].id, data, 6)}
                              email />
                              :
                          ""
                          } 
                          </div>
                          
                        </div>
                      )
                    : null
                  }
                </div>
                
                {
                  bookingCheckout && this.multipaymentActivated()
                    ?
                    <div>
                      <div className="cart-title">
                        4 {formatMessage(messages.payment)}
                      </div>
                      <div class="container multiPaymentBoxBlock">
                        <div class="row">
                          <div className={"column multiPaymentBox cart-voucher-element cart-summary-coupon cart-summary-coupon--mobile" + (!this.state.multiPayment ? " cart-form-selected" : "")} onClick={() => this.changeMultipayment(false)}>
                            {(this.state.multiPaymentLoader && this.state.multiPayment) ? 
                            <div className="loader-overlay">
                              <div className="loader"></div>
                            </div> : null
                            }
                            <div class="cart-form-checkbox cart-form-checkbox--checked">
                              <div class="multiPaymentBoxContainer">
                                <div class="multiPaymentBoxItem cart-item-header cart-item-section">
                                  {formatMessage(messages.multiPaymentDisabled)}
                                </div>
                                <div class="multiPaymentBoxItem cart-headline">
                                  {formatMessage(messages.multiPaymentDisabledText)}
                                </div>
                              </div>
                              <div class="multiPaymentBoxCheckbox">
                                <input type="checkbox" class="cart-form-check cart-voucher-element-checkbox" checked={!this.state.multiPayment ? "checked" : ""} />
                                <span class="checkmark"></span>
                              </div>
                            </div>
                          </div>
                          {this.multipaymentActivated() ?
                            <div className={"column multiPaymentBox cart-voucher-element cart-summary-coupon cart-summary-coupon--mobile" + (this.state.multiPayment ? " cart-form-selected" : "")} onClick={() => this.changeMultipayment(true)}>
                              {(this.state.multiPaymentLoader && !this.state.multiPayment) ? 
                              <div className="loader-overlay">
                                <div className="loader"></div>
                              </div> : null
                              }
                              <div class="cart-form-checkbox cart-form-checkbox--checked">
                                <div class="multiPaymentBoxContainer">
                                  <div class="multiPaymentBoxItem cart-item-header cart-item-section">
                                    {formatMessage(messages.multiPaymentEnabled)} { this.state.multiPaymentFee > 0 ? <span class="multiPaymentFee">(+{this.state.multiPaymentFee}€)</span> : ""}
                                  </div>
                                  <div class="multiPaymentBoxItem cart-headline">
                                    {formatMessage(messages.multiPaymentEnabledText)}
                                  </div>
                                </div>
                                <div class="multiPaymentBoxCheckbox">
                                  <input type="checkbox" class="cart-form-check cart-voucher-element-checkbox" checked={this.state.multiPayment ? "checked" : ""} />
                                  <span class="checkmark"></span>
                                </div>
                              </div>
                            </div>
                          : "" }
                        </div>
                        {this.state.multiPayment ?
                          <div class="multiPaymentEmail">
                            <div class="cart-item-header">Veuillez indiquer les mails des payeurs (le paiement sera divisé par le nombre de débiteurs) :</div>
                            <div className="">
                              <p id="cart-multi-payment-email-error-anchor"></p>
                              {
                                !this.state.multiPaymentFormIsValid
                                  ?
                                  <div className="cart-summary-error cart-summary-section">
                                    <p>{formatMessage(messages.informationErrorMultiPayment)}</p>
                                  </div>
                                  : null
                              }
                            </div>
                            {this.state.multiPaymentEmails.map((email, index) => (
                              <div className="cart-form-fields-row multiPaymentEmailPlayerField" key={index} style={{ display: 'flex', alignItems: 'center'}}>
                                <div class="multiPaymentEmailPlayerFieldCol1">
                                <Field
                                  id={`email-player-${index + 1}`}
                                  name={`emailPayer${index + 1}`}
                                  placeholder={formatMessage(messages.multiPaymentEmailPlaceholder) + " " + (index + 1)}
                                  onChange={(data) => this.handleMultiPaymentEmailChange(index, data)}
                                  email
                                  input={email}
                                  disabled={index == 0 ? "disabled" : "" }
                                />
                                </div>
                                <div class="multiPaymentEmailPlayerFieldCol2">
                                {index > 0 && (
                                  <a onClick={() => this.removeMultiPaymentEmailField(index)}>
                                      <svg fill="#5F5F5F" height="32" width="32" xmlns="http://www.w3.org/2000/svg"
                                      viewBox="0 0 457.503 457.503">
                                          <path d="M381.575,57.067h-90.231C288.404,25.111,261.461,0,228.752,0C196.043,0,169.1,25.111,166.16,57.067H75.929 c-26.667,0-48.362,21.695-48.362,48.362c0,26.018,20.655,47.292,46.427,48.313v246.694c0,31.467,25.6,57.067,57.067,57.067 h195.381c31.467,0,57.067-25.6,57.067-57.067V153.741c25.772-1.02,46.427-22.294,46.427-48.313 C429.936,78.761,408.242,57.067,381.575,57.067z M165.841,376.817c0,8.013-6.496,14.509-14.508,14.509 c-8.013,0-14.508-6.496-14.508-14.509V186.113c0-8.013,6.496-14.508,14.508-14.508c8.013,0,14.508,6.496,14.508,14.508V376.817z M243.26,376.817c0,8.013-6.496,14.509-14.508,14.509c-8.013,0-14.508-6.496-14.508-14.509V186.113 c0-8.013,6.496-14.508,14.508-14.508c8.013,0,14.508,6.496,14.508,14.508V376.817z M320.679,376.817 c0,8.013-6.496,14.509-14.508,14.509c-8.013,0-14.509-6.496-14.509-14.509V186.113c0-8.013,6.496-14.508,14.509-14.508 s14.508,6.496,14.508,14.508V376.817z"/>
                                    </svg>
                                  </a>
                                )}
                                </div>
                              </div>
                            ))}
                            { this.state.multiPaymentEmails.length < this.state.maxMultiPaymentEmails ?
                              <div className="multiPaymentEmailPlayerAdd cart-title-modify pass-culture-plus">
                                <a onClick={this.addMultiPaymentEmailField}><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="8" r="7.5" stroke="#0565BE" /><path d="M12 7.43902H8.56098V4H7.43902V7.43902H4V8.56098H7.43902V12H8.56098V8.56098H12V7.43902Z" fill="#0565BE" /></svg>
                                  {formatMessage(messages.multiPaymentAddEmail)}</a>
                              </div>
                              : null
                            }

                            <div class="cart-item-header multiPaymentAmountTitle">{formatMessage(messages.multiPaymentAmountTitle)} : <span class="multiPaymentAmount">{this.getMultiPaymentAmountPerPlayer()} €</span></div>
                          </div>
                        : null}
                      </div>
                    </div>
                    : null
                }

                <div className="cart-summary-total-price">
                  {
                      this.state.userAcceptsTermsError
                      ?
                        <div className="cart-summary-error cart-summary-section">
                          <p>{formatMessage(messages.acceptTermsError)}</p>
                        </div>
                      : null
                  }
                  {
                      this.state.genericError
                      ?
                        <div className="cart-summary-error cart-summary-section">
                          <p>{formatMessage(messages.genericError)} <a href="/contact/">✉️</a></p>
                        </div>
                      : null
                  }
                  {this.state.multiPayment ?
                  <label className="cart-summary-business-terms">
                    <div class="cart-form-checkbox cart-form-information-checkbox"><label>
                      <input 
                      type="checkbox"
                      className={!this.state.userAcceptsTermsError ? "cart-form-check" : "cart-form-check cart-form-check--error"}
                      checked={this.state.multiPaymentAcceptsTerms}
                      onChange={() => this.setState({ multiPaymentAcceptsTerms: !this.state.multiPaymentAcceptsTerms })} />
                      <span class="checkmark"></span></label></div>

                    <p dangerouslySetInnerHTML={{ __html: multiPaymentAcceptTerms }}>
                    </p>
                  </label>
                  : null}
                  <label className="cart-summary-business-terms">
                    <div class="cart-form-checkbox cart-form-information-checkbox"><label>
                      <input 
                      type="checkbox"
                      className={!this.state.userAcceptsTermsError ? "cart-form-check" : "cart-form-check cart-form-check--error"}
                      checked={this.state.userAcceptsTerms}
                      onChange={() => this.setState({ userAcceptsTerms: !this.state.userAcceptsTerms, userAcceptsTermsError: false })} />
                      <span class="checkmark"></span></label></div>

                    <p>
                      {formatMessage(messages.acceptTerms)}
                      <Link to={`/conditions-generales-de-vente/`} target="_blank">{formatMessage(messages.businessTerms)}</Link>
                      {formatMessage(messages.warningTerms)}
            <Link to={`/conditions-annulation/`} target="_blank">{formatMessage(messages.annulationTerms)}</Link>
                    </p>
                  </label>
                  {
                    this.state.order_status == "paid" ?
                      <a aria-disabled={true}><div id="booking-cta-disabled"><div class="learn-more themes-cart-cta cart-button cart-button-pay booking-cta-disabled"><span data-text="{formatMessage(messages.pay)}">Commande déjà payée</span></div></div></a>
                      :
                      <a onClick={() => this.handleCTA()} aria-disabled={this.state.isInPayment}><div id="booking-cta"><div class="learn-more themes-cart-cta cart-button cart-button-pay"><span data-text="{formatMessage(messages.pay)}">{this.state.isInPayment ? formatMessage(messages.wait) : formatMessage(messages.pay)}</span></div></div></a>
                  }
                  
                </div>
                <div class="cart-end-section"></div>
                <div className="cart-cancellation-terms">
                  <p>{formatMessage(messages.inCaseOfCancellation)}</p>
                  <p>{formatMessage(messages.friendlySettlement)} <a href="http://www.mtv.travel/?page=saisine-du-mediateur">{formatMessage(messages.friendlySettlementLink)}</a></p>
                </div>


                <div>
              </div>


          </div>
          )
    }

    return <div className="cart-container-display"><div className="cart-container-display-left"></div>{r}{cartTotal}<div className="cart-container-display-right"></div></div>;
  }
}

const messages = defineMessages({
  backToBooking: {
    id: 'cart.backToBooking',
    defaultMessage: "Revenir au calendrier de réservation"
  },
  backToGiftCard: {
    id: 'cart.backToGiftCard',
    defaultMessage: "Revenir à la carte cadeaux"
  },
  reservationNew: {
    id: 'cartItem.reservationNew',
    defaultMessage: '+ Ajouter une autre partie'
  },
  information: {
    id: 'cart.information',
    defaultMessage: "Coordonnées"
  },
  customerInformation: {
    id: 'cart.customerInformation',
    defaultMessage: "Renseignements sur la personne effectuant la réservation"
  },
  companyInformation: {
    id: 'cart.companyInformation',
    defaultMessage: "Renseignements sur la société"
  },
  informationError: {
    id: 'cart.informationError',
    defaultMessage: "Veuillez renseigner les champs obligatoires"
  },
  informationErrorMultiPayment: {
    id: 'cart.informationErrorMultiPayment',
    defaultMessage: "Veuillez renseigner les champs obligatoires. Les emails des participants doivent être valides, et uniques."
  },
  informationFirstName: {
    id: 'cart.informationFirstName',
    defaultMessage: "Prénom"
  },
  informationLastName: {
    id: 'cart.informationLastName',
    defaultMessage: "Nom"
  },
    informationPhone: {
    id: 'cart.informationPhone',
    defaultMessage: "Téléphone"
  },
    informationEmail: {
    id: 'cart.informationEmail',
    defaultMessage: "Email"
  },
    informationComment: {
    id: 'cart.informationComment',
    defaultMessage: "Commentaire (facultatif)"
  },
    informationIsCorporate: {
    id: 'cart.informationIsCorporate',
    defaultMessage: "Vous êtes une entreprise"
  },
    informationCompanyName: {
    id: 'cart.informationCompanyName',
    defaultMessage: "Nom de la société"
  },
    informationCompanyAddress: {
    id: 'cart.informationCompanyAddress',
    defaultMessage: "Adresse"
  },
    informationCompanyPostalCode: {
    id: 'cart.informationCompanyPostalCode',
    defaultMessage: "Code Postal"
  },
    informationCompanyCity: {
    id: 'cart.informationCompanyCity',
    defaultMessage: "Ville"
  },
    informationPaperCardNote: {
    id: 'cart.informationPaperCardNote',
    defaultMessage: "Ajouter ici un petit mot pour l'heureux élu :-)"
  },
    informationReceiver: {
    id: 'cart.informationReceiver',
    defaultMessage: "Coordonnées destinataire :"
  },
    informationGiftCardReceiver: {
    id: 'cart.informationGiftCardReceiver',
    defaultMessage: "Renseignements sur la personne réceptrice du coupon cadeau :"
  },
    informationCountry: {
    id: 'cart.informationCountry',
    defaultMessage: "Pays"
  },
    informationSendToPlayers: {
    id: 'cart.informationSendToPlayers',
    defaultMessage: "Envoyer une confirmation aux autres participants (facultatif)"
  },
    informationSendToPlayersDate: {
    id: 'cart.informationSendToPlayersDate',
    defaultMessage: "Date"
  },
    informationSendToPlayersUserIsPlaying: {
    id: 'cart.informationSendToPlayersUserIsPlaying',
    defaultMessage: "Je participe à cette session de jeu"
  },
    informationSendToPlayersEmails: {
    id: 'cart.informationSendToPlayersEmails',
    defaultMessage: "Vous voulez impliquer tous vos coéquipiers ? Renseignez leur email afin qu’ils recoivent tous les informations nécessaires la veille de leur venue"
  },
    informationPlayerEmail1: {
    id: 'cart.informationPlayerEmail1',
    defaultMessage: "Email Joueur n°1"
  },
    informationPlayerEmail2: {
    id: 'cart.informationPlayerEmail2',
    defaultMessage: "Email Joueur n°2"
  },
    informationPlayerEmail3: {
    id: 'cart.informationPlayerEmail3',
    defaultMessage: "Email Joueur n°3"
  },
    informationPlayerEmail4: {
    id: 'cart.informationPlayerEmail4',
    defaultMessage: "Email Joueur n°4"
  },
    informationPlayerEmail5: {
    id: 'cart.informationPlayerEmail5',
    defaultMessage: "Email Joueur n°5"
  },
  informationPlayerEmail6: {
    id: 'cart.informationPlayerEmail6',
      defaultMessage: "Email Joueur n°6"
  },
    acceptTermsError: {
    id: 'cart.acceptTermsError',
    defaultMessage: "Veuillez accepter les conditions générales de ventes"
  },
    genericError: {
    id: 'cart.genericError',
    defaultMessage: "Une erreur s'est produite. Veuillez nous contacter : "
  },
    summaryTitle: {
    id: 'cart.summaryTitle',
    defaultMessage: "Récapitulatif de commande"
  },
    summaryTitleMobile: {
    id: 'cart.summaryTitleMobile',
    defaultMessage: "Voir mon récapitulatif de commande"
  },
    giftCard: {
    id: 'cart.giftCard',
    defaultMessage: "Carte cadeaux"
  },
    game: {
    id: 'cart.game',
    defaultMessage: "partie"
  },
    player: {
    id: 'cart.player',
    defaultMessage: "joueur"
  },
    sendByPaperCard: {
    id: 'cart.sendByPaperCard',
    defaultMessage: "Envoi par carte cadeaux"
  },
    sendByEmail: {
    id: 'cart.sendByEmail',
    defaultMessage: "Envoi par email"
  },
    shippingRates: {
    id: 'cart.shippingRates',
    defaultMessage: "2 €"
  },
    shippingFree: {
    id: 'cart.shippingFree',
    defaultMessage: "GRATUIT"
  },
    couponCodeAdd: {
    id: 'cart.couponCodeAdd',
    defaultMessage: "Ajouter mon code promo"
  },
    couponCodeApply: {
    id: 'cart.couponCodeApply',
    defaultMessage: "Appliquer"
  },
    couponCodeError: {
    id: 'cart.couponCodeError',
    defaultMessage: "Code Inconnu"
  },
  totalPrice: {
    id: 'cart.totalPrice',
    defaultMessage: "Montant total"
  },
  totalCart: {
    id: 'cart.totalCart',
    defaultMessage: "Montant total"
  },
    acceptTerms: {
    id: 'cart.acceptTerms',
    defaultMessage: "J'accepte les"
  },
    warningTerms: {
    id: 'cart.warningTerms',
    defaultMessage: " et j'ai bien pris conscience qu'il s'agit d'une activité sur réservation non remboursable. "
  },
    businessTerms: {
    id: 'cart.businessTerms',
    defaultMessage: "conditions générales de vente"
  },
    annulationTerms: {
    id: 'cart.annulationTerms',
    defaultMessage: "Modalités d’annulation et de modification d’une session de jeu"
  },
    covidTerms: {
    id: 'cart.covidTerms',
    defaultMessage: ". J'ai compris que la participation est conditionnée à la présentation d'un pass sanitaire valide"
  },
    pay: {
    id: 'cart.pay',
    defaultMessage: "confirmer et payer"
  },
  inCaseOfCancellation: {
  id: 'cart.inCaseOfCancellation',
  defaultMessage: "En cas d’annulation d'une session de la part du Client, aucun remboursement ne sera effectué conformément à l’article L 221-28 du code de la consommation. Un client ayant acheté un bon cadeau par internet peut faire exercer son droit de rétractation jusqu’à 14 jours après l’achat, si le bon cadeau n’a pas été utilisé."
  },
  friendlySettlement: {
  id: 'cart.friendlySettlement',
  defaultMessage: "Conformément à l’ordonnance n°2015-1033 du 20 août 2015 et au décret d’application n°2015-1382 du 30 octobre 2015, tout différend ou litige dit de consommation, sous réserve de l'article L.152-2 du code de la consommation, peut faire l'objet d'un règlement amiable par médiation auprès du"
  },
  friendlySettlementLink: {
  id: 'cart.friendlySettlementLink',
  defaultMessage: " MTV.Travel – Médiation Tourisme et Voyage."
  },
  confirm: {
  id: 'cart.confirm',
  defaultMessage: "Confirmer"
  },
  next: {
  id: 'cart.next',
  defaultMessage: "Suivant"
  },
  noDiscount: {
  id: 'cart.noDiscount',
  defaultMessage: "Pas de code promo"
  },
  cart: {
  id: 'cart.cart',
  defaultMessage: "Panier"
  },
  cartHeadlineCart: {
  id: 'cart.cartHeadlineCart',
  defaultMessage: "Voici le récapitulatif de votre commande. Il n'est pas trop tard pour la modifier."
  },
  voucher: {
  id: 'cart.voucher',
  defaultMessage: "Code Promo"
  },
  cartHeadlineVoucher: {
  id: 'cart.cartHeadlineVoucher',
  defaultMessage: "Vous pouvez cumuler les bons, pour payer l’intégralité ou une partie de votre commande ou simplement passer cette étape si vous n’en avez pas."
  },
  voucherCheckbox: {
  id: 'cart.voucherCheckbox',
  defaultMessage: "Code Promo / Coupon cadeau One Hour"
  },
  ancvCheckbox: {
  id: 'cart.ancvCheckbox',
  defaultMessage: "Chèque-Vacances Connect"
  },
  passcultureCheckbox: {
  id: 'cart.passcultureCheckbox',
  defaultMessage: "Pass Culture"
  },
  voucherSummary: {
  id: 'cart.voucherSummary',
  defaultMessage: "Code Promo / Coupon cadeau"
  },
  games: {
    id: 'cart.games',
    defaultMessage: "Parties"
  },
  options: {
    id: 'cart.options',
    defaultMessage: "Options"
  },
  discount: {
    id: 'cart.discount',
    defaultMessage: "Réductions"
  },
  modify: {
    id: 'cart.modify',
    defaultMessage: "Modifier"
  },
  mandatoryFields: {
    id: 'cart.mandatoryFields',
    defaultMessage: "* Champs obligatoires"
  },
  couponAncvIdentifier: {
    id: 'cart.couponAncvIdentifier',
    defaultMessage: "Votre identifiant chèque vacances"
  },
  voucherAncv: {
    id: 'cart.voucherAncv',
    defaultMessage: "Chèque-Vacances"
  },
  voucherPasseCulture: {
    id: 'cart.voucherPasseCulture',
    defaultMessage: "Pass Culture"
  },
  ancvWarning: {
    id: 'cart.ancvWarning',
    defaultMessage: "Important : l'application Chèque-Vacances est nécessaire pour valider ce paiement"
  },
  smartphonePayment: {
    id: 'cart.smartphonePayment',
    defaultMessage: "Veuillez utiliser votre téléphone mobile ou tablette pour valider le paiement et gardez l'onglet ouvert"
  },
  couponPassCultureReservation: {
    id: 'cart.couponPassCultureReservation',
    defaultMessage: "Contremarque"
  },
  cancel: {
    id: 'cart.cancel',
    defaultMessage: "Annuler"
  },
  addPassCulture: {
    id: 'cart.addPassCulture',
    defaultMessage: "Ajouter un autre pass culture"
  },
  successPassCulture: {
    id: 'cart.successPassCulture',
    defaultMessage: "Code appliqué avec succès"
  },
  headlinePassCulture: {
    id: 'cart.headlinePassCulture',
    defaultMessage: "Retrouvez tous les détails sur notre page "
  },
  wait: {
    id: 'cart.wait',
    defaultMessage: "Veuillez patienter ..."
  },


  payment: {
    id: 'cart.payment',
    defaultMessage: "Moyen de paiement"
  },
  multiPaymentDisabled: {
    id: 'cart.multiPaymentDisabled',
    defaultMessage: "Payer la totalité"
  },
  multiPaymentDisabledText: {
    id: 'cart.multiPaymentDisabledText',
    defaultMessage: "Réglez l'intégralité de la réservation maintenant et évitez les frais supplémentaires."
  },
  multiPaymentEnabled: {
    id: 'cart.multiPaymentEnabled',
    defaultMessage: "Paiement partagé"
  },
  multiPaymentEnabledText: {
    id: 'cart.multiPaymentEnabledText',
    defaultMessage: "Payez votre part, une demande de paiement sera automatiquement envoyée à vos amis."
  },
  multiPaymentEmailPlaceholder: {
    id: 'cart.multiPaymentEmailPlaceholder',
    defaultMessage: "Email payeur"
  },
  multiPaymentAddEmail: {
    id: 'cart.multiPaymentAddEmail',
    defaultMessage: "Ajouter un autre payeur"
  },
  multiPaymentAmountTitle: {
    id: 'cart.multiPaymentAmountTitle',
    defaultMessage: "Chaque personne devra payer"
  },
  multiPaymentAcceptTerms: {
    id: 'cart.multiPaymentAcceptTerms',
    defaultMessage: "J'ai bien conscience que si le paiement partagé des autres payeurs n'a pas été effectué sous 24h, une empreinte bancaire sera effectuée et la <b>totalité du restant à payer</b> sera automatiquement débitée sur ma carte bancaire."
  },
  multiPaymentOption: {
    id: 'cart.multiPaymentOption',
    defaultMessage: "Frais de paiement partagé"
  },          
  
})

export default withRouter(injectIntl(Cart))



// WEBPACK FOOTER //
// ./src/components/Cart.js